export const TOPICS = [

    // ══════════════════════════════════════════════════════════════════════
    // A1 LIVELLO 1: PRIMI PASSI
    // ══════════════════════════════════════════════════════════════════════
  
    {
      slug: 'presentazioni',
      name: 'Presentazioni & Saluti',
      emoji: '👋',
      words: [
        { italian: 'Come ti chiami? / Qual è il tuo nome?', english: "What's your name?", options: ["How are you?", "What time is it?", "What's her name?"] },
        { italian: 'Mi chiamo ___ / Il mio nome è ___', english: 'My name is ___', options: ["I am ___", "I am from ___", "I have ___"] },
        { italian: 'Quanti anni hai?', english: 'How old are you?', options: ["How are you?", "What time is it?", "What's your name?"] },
        { italian: 'Ho ___ anni', english: "I'm ___ years old", options: ["I have ___ dogs", "I am ___ tall", "She is ___ years old"] },
        { italian: 'Da dove vieni? / Di dove sei?', english: 'Where are you from?', options: ["How are you?", "What time is it?", "What's her name?"] },
        { italian: 'Vengo da ___ / Sono di ___', english: "I'm from ___", options: ["I live in ___", "I have ___", "I am ___"] },
        { italian: 'Piacere di conoscerti', english: 'Nice to meet you (Informal)', options: ["See you later", "See you tomorrow", "Thank you."] },
        { italian: 'Piacere di conoscerla', english: 'Nice to meet you (Formal)', options: ["See you later", "See you tomorrow", "Thank you."] },
        { italian: 'Come stai?', english: 'How are you?', options: ["Are you ok?", "What time is it?", "Where are you from?"] },
        { italian: 'Come va?', english: 'How are you?', options: ["How are you?", "What time is it?", "Do you have any dogs?"] },
        { italian: 'Bene', english: 'Good', options: ["Bad", "So so", "Very well"] },
        { italian: 'Abbastanza bene', english: 'Pretty good', options: ["Very good", "Not good", "Very bad"] },
        { italian: 'Molto bene / Benissimo', english: 'Very good', options: ["Very bad", "So so", "Not bad"] },
        { italian: "Non c'è male", english: 'Not bad', options: ["Bad", "Very bad", "Pretty good"] },
        { italian: 'Così così', english: 'So so', options: ["Good", "Pretty good", "So bad"] },
        { italian: 'Male', english: 'Bad', options: ["Good", "So so", "Not bad"] },
        { italian: 'Ciao', english: 'Hi / Bye', emoji: '👋', options: ["Good morning", "Good evening", "Good afternoon"] },
        { italian: 'Salve', english: 'Hi', emoji: '👋', options: ["Goodbye", "Good morning", "Bye"] },
        { italian: 'Buongiorno', english: 'Good morning', emoji: '🌅', options: ["Good evening", "Good afternoon", "Goodnight"] },
        { italian: 'Buon pomeriggio', english: 'Good afternoon', emoji: '☀️', options: ["Good morning", "Good evening", "Goodnight"] },
        { italian: 'Buonasera', english: 'Good evening', emoji: '🌆', options: ["Good morning", "Good afternoon", "Goodnight"] },
        { italian: 'Buonanotte', english: 'Goodnight', emoji: '🌙', options: ["Good evening", "Good morning", "Good afternoon"] },
        { italian: 'Arrivederci', english: 'Goodbye', emoji: '👋', options: ["Good morning", "See you tomorrow", "Hi"] },
        { italian: 'A dopo', english: 'See you later', emoji: '👋', options: ["Hi", "Goodbye", "See you tomorrow"] },
        { italian: 'A presto', english: 'See you soon', emoji: '👋', options: ["Bye", "See you tomorrow", "Goodbye"] },
        { italian: 'A domani', english: 'See you tomorrow', emoji: '👋', options: ["See you soon", "See you later", "Goodbye"] },
        { italian: 'Ci vediamo', english: 'See you', emoji: '👋', options: ["Goodbye", "See you tomorrow", "Nice to meet you"] },
      ],
    },
  
    {
      slug: 'non_capisco',
      name: 'Quando Non Capisco',
      emoji: '🤔',
      words: [
        { italian: 'Cosa? / Come? / Prego?', english: 'What?', emoji: '❓', options: ["When?", "Why?", "Who?"] },
        { italian: 'Come si dice ___ in italiano?', english: 'How do you say ___ in Italian?', emoji: '❓', options: ["What does ___ mean?", "How do you spell ___?", "Can you repeat ___?"] },
        { italian: 'Cosa vuol dire ___?', english: 'What does ___ mean?', emoji: '❓', options: ["How do you say ___?", "Can you repeat ___?", "How do you spell ___?"] },
        { italian: 'Ripeti, per favore', english: 'Repeat, please', options: ["I understand!", "Speak slowly, please", "Can you explain?"] },
        { italian: 'Parla piano, per favore / Parla lentamente, per favore', english: 'Speak slowly, please', options: ["Repeat, please", "I don't understand", "I don't know"] },
        { italian: 'Capisco', english: 'I understand', emoji: '✅', options: ["I don't understand", "I know", "Excuse me"] },
        { italian: 'Non capisco', english: "I don't understand", emoji: '❌', options: ["I understand", "I don't know", "Excuse me"] },
        { italian: 'Scusa / Scusami', english: 'Excuse me (informal)', options: ["Excuse me (formal)", "I know", "Thank you"] },
        { italian: 'Scusi / Mi scusi', english: 'Excuse me (formal)', options: ["Excuse me (informal)", "I know", "I don't know"] },
        { italian: 'Non lo so / Non so', english: "I don't know", options: ["I don't understand", "I know", "Excuse me"] },
        { italian: 'Lo so', english: "I know", options: ["I don't understand", "I don't know", "Excuse me"] },


      ],
    },
  
    {
      slug: 'numeri',
      name: 'I Numeri',
      emoji: '🔢',
      words: [
        { italian: 'zero', english: '0', options: ["1", "2", "10"] },
        { italian: 'uno', english: '1', options: ["2", "11", "7"] },
        { italian: 'due', english: '2', options: ["12", "3", "20"] },
        { italian: 'tre', english: '3', options: ["13", "30", "23"] },
        { italian: 'quattro', english: '4', options: ["14", "40", "24"] },
        { italian: 'cinque', english: '5', options: ["15", "50", "25"] },
        { italian: 'sei', english: '6', options: ["16", "60", "26"] },
        { italian: 'sette', english: '7', options: ["17", "70", "27"] },
        { italian: 'otto', english: '8', options: ["18", "80", "28"] },
        { italian: 'nove', english: '9', options: ["19", "90", "29"] },
        { italian: 'dieci', english: '10', options: ["12", "20", "15"] },
        { italian: 'undici', english: '11', options: ["21", "10", "12"] },
        { italian: 'dodici', english: '12', options: ["11", "22", "20"] },
        { italian: 'tredici', english: '13', options: ["30", "12", "14"] },
        { italian: 'quattordici', english: '14', options: ["40", "13", "24"] },
        { italian: 'quindici', english: '15', options: ["50", "14", "25"] },
        { italian: 'sedici', english: '16', options: ["60", "15", "26"] },
        { italian: 'diciassette', english: '17', options: ["70", "16", "27"] },
        { italian: 'diciotto', english: '18', options: ["80", "17", "28"] },
        { italian: 'diciannove', english: '19', options: ["90", "18", "29"] },
        { italian: 'venti', english: '20', options: ["12", "200", "22"] },
        { italian: 'trenta', english: '30', options: ["13", "300", "23"] },
        { italian: 'quaranta', english: '40', options: ["14", "400", "24"] },
        { italian: 'cinquanta', english: '50', options: ["15", "500", "25"] },
        { italian: 'sessanta', english: '60', options: ["16", "600", "26"] },
        { italian: 'settanta', english: '70', options: ["17", "700", "27"] },
        { italian: 'ottanta', english: '80', options: ["18", "800", "28"] },
        { italian: 'novanta', english: '90', options: ["19", "900", "29"] },
        { italian: 'cento', english: '100', options: ["1,000", "10", "1,000,000"] },
        { italian: 'mille', english: '1,000', options: ["100", "10,000", "1,000,000"] },
        { italian: 'un milione', english: '1,000,000', options: ["1,000", "100,000", "1,000,000,000"] },
        { italian: 'un miliardo', english: '1,000,000,000', options: ["1,000,000", "100,000,000", "10,000,000"] },
      ],
    },
  
        {
            slug: 'calendario',
            name: 'Il Calendario',
            emoji: '📅',
            words: [
              { italian: 'lunedì', english: 'Monday', emoji: '📅', options: ["Tuesday", "Sunday", "Wednesday"] },
              { italian: 'martedì', english: 'Tuesday', emoji: '📅', options: ["Monday", "Wednesday", "Thursday"] },
              { italian: 'mercoledì', english: 'Wednesday', emoji: '📅', options: ["Tuesday", "Thursday", "Monday"] },
              { italian: 'giovedì', english: 'Thursday', emoji: '📅', options: ["Wednesday", "Friday", "Tuesday"] },
              { italian: 'venerdì', english: 'Friday', emoji: '📅', options: ["Thursday", "Saturday", "Wednesday"] },
              { italian: 'sabato', english: 'Saturday', emoji: '🎉', options: ["Friday", "Sunday", "Monday"] },
              { italian: 'domenica', english: 'Sunday', emoji: '😴', options: ["Saturday", "Monday", "Friday"] },
              { italian: 'gennaio', english: 'January', emoji: '❄️', options: ["February", "December", "March"] },
              { italian: 'febbraio', english: 'February', emoji: '❤️', options: ["January", "March", "April"] },
              { italian: 'marzo', english: 'March', emoji: '🌱', options: ["February", "April", "May"] },
              { italian: 'aprile', english: 'April', emoji: '🌸', options: ["March", "May", "February"] },
              { italian: 'maggio', english: 'May', emoji: '🌺', options: ["April", "June", "March"] },
              { italian: 'giugno', english: 'June', emoji: '☀️', options: ["May", "July", "April"] },
              { italian: 'luglio', english: 'July', emoji: '🏖️', options: ["June", "August", "May"] },
              { italian: 'agosto', english: 'August', emoji: '🌞', options: ["July", "September", "June"] },
              { italian: 'settembre', english: 'September', emoji: '🍂', options: ["August", "October", "July"] },
              { italian: 'ottobre', english: 'October', emoji: '🎃', options: ["September", "November", "August"] },
              { italian: 'novembre', english: 'November', emoji: '🍁', options: ["October", "December", "September"] },
              { italian: 'dicembre', english: 'December', emoji: '🎄', options: ["November", "January", "October"] },
              { italian: 'primavera', english: 'spring', emoji: '🌸', options: ["summer", "autumn", "winter"] },
              { italian: 'estate', english: 'summer', emoji: '☀️', options: ["spring", "autumn", "winter"] },
              { italian: 'autunno', english: 'autumn', emoji: '🍂', options: ["spring", "summer", "winter"] },
              { italian: 'inverno', english: 'winter', emoji: '❄️', options: ["spring", "summer", "autumn"] },
            ],
          },
          
          {
            slug: 'espressioni_tempo',
            name: 'Espressioni di Tempo',
            emoji: '⏰',
            words: [
              { italian: "l'altro ieri / avantieri", english: 'the day before yesterday' },
              { italian: 'ieri', english: 'yesterday' },
              { italian: 'oggi', english: 'today', emoji: '📆' },
              { italian: 'domani', english: 'tomorrow' },
              { italian: 'dopodomani', english: 'the day after tomorrow' },
              { italian: 'la mattina', english: 'morning', emoji: '🌅' },
              { italian: 'il pomeriggio', english: 'afternoon', emoji: '☀️' },
              { italian: 'la sera', english: 'evening', emoji: '🌆' },
              { italian: 'la notte', english: 'night', emoji: '🌙' },
              { italian: 'il sole', english: 'sun', emoji: '☀️' },
              { italian: 'la luna', english: 'moon', emoji: '🌙' },
              { italian: 'la stella', english: 'star', emoji: '⭐' },
              { italian: 'la settimana scorsa', english: 'last week', emoji: '' },
              { italian: 'la settimana prossima', english: 'next week', emoji: '' },
              { italian: 'il mese scorso', english: 'last month', emoji: '' },
              { italian: 'il mese prossimo', english: 'next month', emoji: '' },
              { italian: "l'anno scorso", english: 'last year', emoji: '' },
              { italian: "l'anno prossimo", english: 'next year', emoji: '' },
              { italian: 'ogni giorno', english: 'every day', emoji: '🔄' },
              { italian: 'ogni settimana', english: 'every week', emoji: '🔄' },
              { italian: 'di solito', english: 'usually', emoji: '🔄' },
              { italian: 'spesso', english: 'often', emoji: '🔄' },
              { italian: 'a volte', english: 'sometimes', emoji: '' },
              { italian: 'raramente', english: 'rarely', emoji: '' },
              { italian: 'mai', english: 'never', emoji: '❌' },
              { italian: 'sempre', english: 'always', emoji: '✅' },
              { italian: 'presto', english: 'early / soon', emoji: '⏰' },
              { italian: 'tardi', english: 'late', emoji: '⏰' },
            ],
          },
  
    {
      slug: 'giorni_speciali',
      name: 'I Giorni Speciali',
      emoji: '🎉',
      words: [
        { italian: 'il compleanno', english: 'birthday', emoji: '🎂' },
        { italian: 'il regalo', english: 'gift / present', emoji: '🎁' },
        { italian: 'la torta', english: 'cake', emoji: '🎂' },
        { italian: 'le candeline', english: 'birthday candles', emoji: '🕯️' },
        { italian: 'il biglietto di auguri', english: 'greeting card', emoji: '💌' },
        { italian: 'la vacanza', english: 'holiday / vacation', emoji: '🏖️' },
        { italian: 'il matrimonio', english: 'wedding', emoji: '💍' },
        { italian: 'la sposa', english: 'bride', emoji: '👰' },
        { italian: 'lo sposo', english: 'groom', emoji: '🤵' },
        { italian: "la damigella d'onore", english: 'bridesmaid', emoji: '💐' },
        { italian: 'il fotografo', english: 'photographer', emoji: '📸' },
        { italian: 'la macchina fotografica', english: 'camera', emoji: '📷' },
        { italian: 'il Natale', english: 'Christmas', emoji: '🎄' },
        { italian: 'Babbo Natale', english: 'Santa', emoji: '🎅' },
        { italian: "l'albero di Natale", english: 'Christmas tree', emoji: '🎄' },
        { italian: 'la slitta', english: 'sleigh', emoji: '🛷' },
        { italian: 'la renna', english: 'reindeer', emoji: '🦌' },
      ],
    },
  
    // ══════════════════════════════════════════════════════════════════════
    // A1 LIVELLO 2: IN CITTÀ
    // ══════════════════════════════════════════════════════════════════════

    {
      slug: 'città',
      name: 'La Città & Le Indicazioni Stradali',
      emoji: '🏙️',
      words: [
        { italian: "l'ufficio postale / la posta", english: 'post office', emoji: '📮' },
        { italian: 'il cinema', english: 'movie theater', emoji: '🎬' },
        { italian: "l'albergo", english: 'hotel', emoji: '🏨' },
        { italian: 'la scuola', english: 'school', emoji: '🏫' },
        { italian: 'il tabacchino', english: 'tobacco shop' },
        { italian: "l'edicola", english: 'kiosk' },
        { italian: "l'ufficio", english: 'office', emoji: '🏢' },
        { italian: 'il museo', english: 'museum', emoji: '🏛️' },
        { italian: 'la farmacia', english: 'pharmacy', emoji: '💊' },
        { italian: 'il panificio', english: 'bakery', emoji: '🥖' },
        { italian: 'il supermercato', english: 'grocery store', emoji: '🛒' },
        { italian: 'la stazione di polizia', english: 'police station', emoji: '👮' },
        { italian: 'il bar', english: 'cafe', emoji: '☕' },
        { italian: 'lo zoo', english: 'zoo', emoji: '🦁' },
        { italian: 'il ristorante', english: 'restaurant', emoji: '🍝' },
        { italian: "l'ospedale", english: 'hospital', emoji: '🏥' },
        { italian: 'la chiesa', english: 'church', emoji: '⛪' },
        { italian: 'la banca', english: 'bank', emoji: '🏦' },
        { italian: 'la stazione', english: 'station', emoji: '🚉' },
        { italian: "l'aeroporto", english: 'airport', emoji: '✈️' },
        { italian: 'il mercato', english: 'farmer\'s market', emoji: '🛒' },
        { italian: 'lo stadio', english: 'stadium', emoji: '🏟️' },
        { italian: 'il parco', english: 'park', emoji: '🌳' },
        { italian: 'il negozio', english: 'shop', emoji: '🏪' },
        { italian: 'il comune', english: 'town hall / municipality', emoji: '🏛️' },
        { italian: 'la biblioteca', english: 'library', emoji: '📚' },
        { italian: 'il teatro', english: 'theatre', emoji: '🎭' },
        { italian: 'la galleria d\'arte', english: 'art gallery', emoji: '🖼️' },
        { italian: 'il mercato coperto', english: 'covered market', emoji: '🏪' },
        { italian: 'la palestra', english: 'gym', emoji: '🏋️' },
        { italian: 'la piscina', english: 'swimming pool', emoji: '🏊' },
        { italian: 'il porto', english: 'port / harbour', emoji: '⚓' },
        { italian: 'la piazza', english: 'square', emoji: '🏛️' },
        { italian: 'il ponte', english: 'bridge', emoji: '🌉' },
        { italian: 'il semaforo', english: 'traffic light', emoji: '🚦' },
        { italian: 'le strisce pedonali', english: 'crosswalk', emoji: '🚶' },
        { italian: 'il lampione', english: 'street lamp', emoji: '💡' },
        { italian: 'il palazzo', english: 'building', emoji: '🏢' },
        { italian: 'la fabbrica', english: 'factory', emoji: '🏭' },
        { italian: 'il marciapiede', english: 'sidewalk' },
        { italian: 'la fontana', english: 'fountain', emoji: '⛲' },
        { italian: 'il parcheggio', english: 'parking lot', emoji: '🅿️' },
        { italian: 'il parchimetro', english: 'parking meter', emoji: '⏱️' },
        { italian: 'la strada', english: 'road', emoji: '🛣️' },
        { italian: 'la via', english: 'road', emoji: '🛣️' },
        { italian: 'il cartello stradale', english: 'road sign', emoji: '🚧' },
        { italian: 'il quartiere', english: 'neighbourhood', emoji: '🏘️' },
        { italian: "l'incrocio", english: 'intersection' },
        { italian: "l'incidente stradale", english: 'car accident', emoji: '🚨' },
        { italian: 'il centro storico', english: 'historic centre', emoji: '🏛️' },
        { italian: 'la periferia', english: 'outskirts / suburbs', emoji: '🏘️' },
        { italian: 'il grattacielo', english: 'skyscraper', emoji: '🏙️' },
        { italian: 'il monumento', english: 'monument', emoji: '🗿' },
        { italian: 'la rotonda', english: 'roundabout', emoji: '🔄' },
        { italian: 'il sottopasso', english: 'underpass', emoji: '🚇' },
        { italian: 'il marciapiede', english: 'pavement / sidewalk', emoji: '🚶' },
        { italian: 'la fermata dell\'autobus', english: 'bus stop', emoji: '🚌' },
        { italian: 'la fermata della metro', english: 'metro stop', emoji: '🚇' },
        { italian: 'il passaggio a livello', english: 'level crossing', emoji: '🚂' },
        { italian: 'Gira a destra', english: 'Turn right', emoji: '➡️' },
        { italian: 'Gira a sinistra', english: 'Turn left', emoji: '⬅️' },
        { italian: 'Sempre dritto', english: 'Keep straight', emoji: '⬆️' },
        { italian: 'lontano', english: 'far away' },
        { italian: 'vicino', english: 'close by' },
        { italian: 'davanti', english: 'in front of' },
        { italian: 'dietro', english: 'behind' },
        { italian: 'a fianco', english: 'next to' },
        { italian: 'dentro', english: 'inside' },
        { italian: 'fuori', english: 'outside' },
        { italian: 'sopra', english: 'above' },
        { italian: 'sotto', english: 'under' },
        { italian: 'qui / qua', english: 'here' },
        { italian: 'lì / là', english: 'there' },
        { italian: "all'inizio", english: 'at the beginning' },
        { italian: 'alla fine', english: 'at the end' },
      ],
    },
  
    {
      slug: 'trasporti',
      name: 'I Trasporti',
      emoji: '🚌',
      words: [
        { italian: 'il taxi', english: 'taxi', emoji: '🚕' },
        { italian: 'il camion', english: 'truck / lorry', emoji: '🚛' },
        { italian: 'il furgone', english: 'van', emoji: '🚐' },
        { italian: "la macchina / l'automobile / l'auto", english: 'car', emoji: '🚗' },
        { italian: 'la moto / la motocicletta', english: 'motorbike', emoji: '🏍️' },
        { italian: 'il motorino', english: 'motor scooter', emoji: '🛵' },
        { italian: 'la metropolitana', english: 'metro', emoji: '🚇' },
        { italian: 'la bicicletta', english: 'bicycle', emoji: '🚲' },
        { italian: "l'autobus", english: 'bus', emoji: '🚌' },
        { italian: 'il rimorchio', english: 'trailer', emoji: '🚛' },
        { italian: 'il monopattino', english: 'scooter', emoji: '🛴' },
        { italian: 'il camper', english: 'RV', emoji: '🚐' },
        { italian: 'la nave', english: 'ship', emoji: '🚢' },
        { italian: 'il traghetto', english: 'ferry', emoji: '⛴️' },
        { italian: "l'aereo", english: 'plane', emoji: '✈️' },
        { italian: 'il treno', english: 'train', emoji: '🚂' },
        { italian: 'i binari', english: 'train tracks', emoji: '🛤️' },
        { italian: 'i vagoni', english: 'train cars', emoji: '🚃' },
        { italian: 'il controllore', english: 'conductor', emoji: '👷' },
        { italian: 'il motore', english: 'engine', emoji: '⚙️' },
        { italian: 'i fari', english: 'headlights', emoji: '💡' },
        { italian: 'la ruota', english: 'wheel', emoji: '⭕' },
        { italian: 'la batteria', english: 'battery', emoji: '🔋' },
        { italian: 'la benzina', english: 'fuel / gas', emoji: '⛽' },
        { italian: "l'olio", english: 'oil', emoji: '🛢️' },
        { italian: 'il carro attrezzi', english: 'tow truck', emoji: '🚛' },
        { italian: 'il distributore di benzina', english: 'petrol station', emoji: '⛽' },
        { italian: 'il pneumatico', english: 'tire', emoji: '⭕' },
        { italian: 'il cofano', english: 'hood' },
        { italian: 'la chiave inglese', english: 'wrench', emoji: '🔧' },
        { italian: "l'autolavaggio", english: 'car wash', emoji: '🚿' },
        { italian: 'la barca', english: 'boat', emoji: '⛵' },
        { italian: "l'elicottero", english: 'helicopter', emoji: '🚁' },
        { italian: 'il biglietto', english: 'ticket', emoji: '🎫' },
        { italian: 'il biglietto di andata', english: 'one-way ticket', emoji: '🎫' },
        { italian: 'il biglietto di andata e ritorno', english: 'return ticket', emoji: '🎫' },
        { italian: 'la prenotazione', english: 'reservation / booking', emoji: '📋' },
        { italian: 'il binario', english: 'train platform', emoji: '🚉' },
        { italian: 'il ritardo', english: 'delay', emoji: '⏰' },
        { italian: 'in orario', english: 'on time', emoji: '✅' },
        { italian: 'la coincidenza', english: 'connection', emoji: '🔄' },
        { italian: 'il capolinea', english: 'terminus / last stop', emoji: '🚌' },
        { italian: 'la corsia preferenziale', english: 'bus lane', emoji: '🚌' },
        { italian: 'il parcheggio', english: 'car park', emoji: '🅿️' },
        { italian: 'la multa', english: 'fine / ticket', emoji: '📋' },
        { italian: 'la patente', english: 'driving licence', emoji: '🪪' },
        { italian: 'la cintura di sicurezza', english: 'seatbelt', emoji: '🔒' },
        { italian: 'il semaforo', english: 'traffic light', emoji: '🚦' },
        { italian: 'il limite di velocità', english: 'speed limit', emoji: '🚗' },
        { italian: 'il senso unico', english: 'one way', emoji: '➡️' },
        { italian: 'il divieto di sosta', english: 'no parking', emoji: '🚫' },
        { italian: 'fare il pieno', english: 'to fill up (with petrol)', emoji: '⛽' },
        { italian: 'chiamare un taxi', english: 'to call a taxi', emoji: '🚕' },
      ],
    },
  
    {
      slug: 'augurare',
      name: 'Augurare Cose Belle',
      emoji: '🥂',
      words: [
        { italian: 'buon pranzo', english: 'enjoy your lunch', emoji: '🍽️', options: ["enjoy your dinner", "enjoy your breakfast", "have a nice day"] },
        { italian: 'buona domenica', english: 'happy Sunday / have a nice Sunday', emoji: '😊', options: ["happy Saturday", "happy Monday", "have a nice weekend"] },
        { italian: 'buon anno', english: 'happy New Year', emoji: '🎆', options: ["Merry Christmas", "happy birthday", "congratulations"] },
        { italian: 'buon viaggio', english: 'have a nice trip', emoji: '✈️', options: ["have fun", "enjoy your vacation", "good luck"] },
        { italian: 'buon divertimento', english: 'have fun', emoji: '🎉', options: ["have a nice trip", "enjoy your meal", "have a good day at work"] },
        { italian: 'buon appetito', english: 'enjoy your meal', emoji: '🍽️', options: ["enjoy your lunch", "enjoy your dinner", "have a nice day"] },
        { italian: 'buona Pasqua', english: 'happy Easter', emoji: '🐣', options: ["Merry Christmas", "happy New Year", "happy birthday"] },
        { italian: 'buon compleanno / auguri', english: 'happy birthday', emoji: '🎂', options: ["congratulations", "happy New Year", "happy Easter"] },
        { italian: 'buon lavoro', english: 'have a good day at work', emoji: '💼', options: ["have a nice weekend", "have fun", "have a nice trip"] },
        { italian: 'buon fine settimana', english: 'have a nice weekend', emoji: '🎉', options: ["have a nice Sunday", "have a good day at work", "enjoy your vacation"] },
        { italian: 'buona giornata', english: 'have a good day', emoji: '☀️', options: ["have a good morning", "have a nice weekend", "have a good evening"] },
        { italian: 'buon Natale', english: 'Merry Christmas', emoji: '🎄', options: ["happy New Year", "happy Easter", "happy birthday"] },
        { italian: 'buona fortuna', english: 'good luck', emoji: '🍀', options: ["have fun", "congratulations", "have a nice trip"] },
        { italian: 'auguri', english: 'happy birthday / congratulations', emoji: '🎉', options: ["good luck", "Merry Christmas", "happy New Year"] },
        { italian: 'buone vacanze', english: 'enjoy your vacation', emoji: '🏖️', options: ["have a nice trip", "have a nice weekend", "have fun"] },
        { italian: 'congratulazioni / auguri', english: 'congratulations', emoji: '🏆', options: ["happy birthday", "good luck", "have fun"] },
      ],
    },
  
    {
      slug: 'avere',
      name: 'Espressioni Idiomatiche Con Avere',
      emoji: '💬',
      words: [
        { italian: 'avere freddo', english: 'to be cold', emoji: '🥶' },
        { italian: 'avere caldo', english: 'to be hot', emoji: '🥵' },
        { italian: 'avere sete', english: 'to be thirsty', emoji: '💧' },
        { italian: 'avere paura', english: 'to be afraid', emoji: '😨' },
        { italian: 'avere fretta', english: 'to be in a hurry', emoji: '⏰' },
        { italian: 'avere ragione', english: 'to be right', emoji: '✅' },
        { italian: 'avere sonno', english: 'to be sleepy', emoji: '😴' },
        { italian: 'avere bisogno di', english: 'to need', emoji: '🙏' },
        { italian: 'avere voglia di', english: 'to want', emoji: '💭' },
        { italian: 'avere fame', english: 'to be hungry', emoji: '🍽️' },
        { italian: 'avere torto', english: 'to be wrong', emoji: '❌' },
      ],
    },


    {
      slug: 'aggettivi_fisici',
      name: 'Descrizione Generale',
      emoji: '👤',
      words: [
        { italian: 'anziano', english: 'old (people)', emoji: '👴🏻' },
        { italian: 'vecchio', english: 'old (things)', emoji: '🏚️' },
        { italian: 'giovane', english: 'young', emoji: '🧒🏼' },
        { italian: 'alto', english: 'tall', emoji: '🦒' },
        { italian: 'basso', english: 'short', emoji: '🤏' },
        { italian: 'bello', english: 'beautiful / handsome', emoji: '😍' },
        { italian: 'brutto', english: 'ugly', emoji: '😬' },
        { italian: 'grande', english: 'big', emoji: '🐘' },
        { italian: 'piccolo', english: 'small', emoji: '🐭' },
        { italian: 'robusto', english: 'chubby', emoji: '🧸' },
        { italian: 'magro', english: 'thin', emoji: '🪶' },
        { italian: 'sportivo', english: 'athletic', emoji: '🏃' },
      ],
    },
    
    {
      slug: 'capelli_occhi',
      name: 'Capelli & Occhi',
      emoji: '👁️',
      words: [
        { italian: 'i capelli biondi', english: 'blond hair', emoji: '👨🏼' },
        { italian: 'i capelli marroni / i capelli castani', english: 'brown hair', emoji: '👦🏽' },
        { italian: 'i capelli rossi', english: 'red hair', emoji: '👩🏼‍🦰' },
        { italian: 'i capelli neri', english: 'black hair', emoji: '👩🏻' },
        { italian: 'i capelli grigi', english: 'grey hair', emoji: '👩🏾‍🦳' },
        { italian: 'i capelli corti', english: 'short hair', emoji: '👨🏻‍🦱' },
        { italian: 'i capelli lunghi', english: 'long hair', emoji: '🧔🏻‍♀️' },
        { italian: 'i capelli lisci', english: 'straight hair', emoji: '👩🏽' },
        { italian: 'i capelli ricci', english: 'curly hair', emoji: '👩🏻‍🦱' },
        { italian: 'i capelli ondulati', english: 'wavy hair', emoji: '〰️' },
        { italian: 'gli occhi azzurri', english: 'blue eyes', emoji: '🩵' },
        { italian: 'gli occhi verdi', english: 'green eyes', emoji: '💚' },
        { italian: 'gli occhi marroni / gli occhi castani', english: 'brown eyes', emoji: '🤎' },
        { italian: 'gli occhi neri', english: 'dark eyes', emoji: '🖤' },
        { italian: 'gli occhi chiari', english: 'light eyes', emoji: '🩵💚' },
        { italian: 'la barba', english: 'beard', emoji: '🧔🏾‍♂️' },
        { italian: 'i baffi', english: 'moustache', emoji: '👴🏻' },
        { italian: 'calvo', english: 'bald', emoji: '👨🏿‍🦲' },
      ],
    },

      
      {
        slug: 'aggettivi_carattere',
        name: 'Carattere & Personalità',
        emoji: '✨',
        words: [
          { italian: 'allegro', english: 'cheerful', emoji: '😄' },
          { italian: 'antipatico', english: 'unfriendly', emoji: '😒' },
          { italian: 'arrabbiato', english: 'angry', emoji: '😠' },
          { italian: 'bravo', english: 'good / capable', emoji: '👍' },
          { italian: 'cattivo', english: 'bad / mean', emoji: '😈' },
          { italian: 'divertente', english: 'fun / entertaining', emoji: '😂' },
          { italian: 'gentile', english: 'kind', emoji: '🤗' },
          { italian: 'intelligente', english: 'intelligent', emoji: '🧠' },
          { italian: 'noioso', english: 'boring', emoji: '😴' },
          { italian: 'pigro', english: 'lazy', emoji: '😪' },
          { italian: 'simpatico', english: 'nice / likable', emoji: '😊' },
          { italian: 'stanco', english: 'tired', emoji: '😓' },
          { italian: 'triste', english: 'sad', emoji: '😢' },
          { italian: 'tranquillo', english: 'calm', emoji: '😌' },
          { italian: 'orgoglioso', english: 'proud', emoji: '🦁' },
          { italian: 'sensibile', english: 'sensitive', emoji: '💙' },
          { italian: 'onesto', english: 'honest', emoji: '🤝' },
          { italian: 'responsabile', english: 'responsible', emoji: '💪' },
          { italian: 'stressato', english: 'stressed', emoji: '😰' },
          { italian: 'nervoso', english: 'nervous', emoji: '😬' },
          { italian: 'estroverso', english: 'outgoing', emoji: '🎉' },
          { italian: 'introverso', english: 'introverted', emoji: '🤫' },
          { italian: 'bugiardo', english: 'liar', emoji: '🤥' },
          { italian: 'felice', english: 'happy', emoji: '😊' },
          { italian: 'preoccupato', english: 'worried', emoji: '😟' },
          { italian: 'sorpreso', english: 'surprised', emoji: '😮' },
          { italian: 'emozionato', english: 'excited', emoji: '🤩' },
          { italian: 'geloso', english: 'jealous', emoji: '😒' },
          { italian: 'timido', english: 'shy', emoji: '😳' },
          { italian: 'coraggioso', english: 'brave', emoji: '🦁' },
          { italian: 'creativo', english: 'creative', emoji: '🎨' },
          { italian: 'ambizioso', english: 'ambitious', emoji: '🏆' },
          { italian: 'curioso', english: 'curious', emoji: '🧐' },
          { italian: 'paziente', english: 'patient', emoji: '😌' },
          { italian: 'impaziente', english: 'impatient', emoji: '😤' },
          { italian: 'ottimista', english: 'optimistic', emoji: '🌟' },
          { italian: 'pessimista', english: 'pessimistic', emoji: '😔' },
        ],
      },
  
    {
      slug: 'colori',
      name: 'I Colori',
      emoji: '🎨',
      words: [
        { italian: 'azzurro', english: 'sky blue', emoji: '🩵', options: ["light blue", "blue", "white"] },
        { italian: 'bianco', english: 'white', emoji: '🤍', options: ["grey", "black", "green"] },
        { italian: 'giallo', english: 'yellow', emoji: '💛', options: ["orange", "red", "green"] },
        { italian: 'grigio', english: 'grey', emoji: '🩶', options: ["white", "green", "black"] },
        { italian: 'nero', english: 'black', emoji: '⬛', options: ["grey", "blue", "brown"] },
        { italian: 'rosso', english: 'red', emoji: '❤️', options: ["orange", "pink", "brown"] },
        { italian: 'celeste', english: 'light blue', emoji: '🩵', options: ["sky blue", "blue", "green"] },
        { italian: 'marrone', english: 'brown', emoji: '🤎', options: ["red", "orange", "black"] },
        { italian: 'verde', english: 'green', emoji: '💚', options: ["white", "yellow", "blue"] },
        { italian: 'arancione', english: 'orange', emoji: '🧡', options: ["yellow", "red", "brown"] },
        { italian: 'rosa', english: 'pink', emoji: '🩷', options: ["red", "purple", "red"] },
        { italian: 'viola', english: 'purple', emoji: '💜', options: ["pink", "blue", "green"] },
        { italian: 'blu', english: 'blue', emoji: '💙', options: ["light blue", "sky blue", "green"] },
      ],
    },
  
    {
      slug: 'nazionalita',
      name: 'Le Nazionalità',
      emoji: '🌍',
      words: [
        { italian: 'americano', english: 'American', emoji: '🇺🇸' },
        { italian: 'canadese', english: 'Canadian', emoji: '🇨🇦' },
        { italian: 'cinese', english: 'Chinese', emoji: '🇨🇳' },
        { italian: 'francese', english: 'French', emoji: '🇫🇷' },
        { italian: 'giapponese', english: 'Japanese', emoji: '🇯🇵' },
        { italian: 'inglese', english: 'English', emoji: '🇬🇧' },
        { italian: 'irlandese', english: 'Irish', emoji: '🇮🇪' },
        { italian: 'olandese', english: 'Dutch', emoji: '🇳🇱' },
        { italian: 'italiano', english: 'Italian', emoji: '🇮🇹' },
        { italian: 'messicano', english: 'Mexican', emoji: '🇲🇽' },
        { italian: 'russo', english: 'Russian', emoji: '🇷🇺' },
        { italian: 'spagnolo', english: 'Spanish', emoji: '🇪🇸' },
        { italian: 'tedesco', english: 'German', emoji: '🇩🇪' },
        { italian: 'indiano', english: 'Indian', emoji: '🇮🇳' },
        { italian: 'tunisino', english: 'Tunisian', emoji: '🇹🇳' },
        { italian: 'brasiliano', english: 'Brazilian', emoji: '🇧🇷' },
        { italian: 'greco', english: 'Greek', emoji: '🇬🇷' },
        { italian: 'polacco', english: 'Polish', emoji: '🇵🇱' },
        { italian: 'egiziano', english: 'Egyptian', emoji: '🇪🇬' },
        { italian: 'argentino', english: 'Argentinian', emoji: '🇦🇷' },
        { italian: 'coreano', english: 'Korean', emoji: '🇰🇷' },
        { italian: 'australiano', english: 'Australian', emoji: '🇦🇺' },
        { italian: 'portoghese', english: 'Portuguese', emoji: '🇵🇹' },
        { italian: 'turco', english: 'Turkish', emoji: '🇹🇷' },
        { italian: 'svizzero', english: 'Swiss', emoji: '🇨🇭' },
        { italian: 'belga', english: 'Belgian', emoji: '🇧🇪' },
        { italian: 'svedese', english: 'Swedish', emoji: '🇸🇪' },
        { italian: 'norvegese', english: 'Norwegian', emoji: '🇳🇴' },
        { italian: 'danese', english: 'Danish', emoji: '🇩🇰' },
        { italian: 'rumeno', english: 'Romanian', emoji: '🇷🇴' },
        { italian: 'ucraino', english: 'Ukrainian', emoji: '🇺🇦' },
        { italian: 'filippino', english: 'Filipino', emoji: '🇵🇭' },
        { italian: 'vietnamita', english: 'Vietnamese', emoji: '🇻🇳' },
        { italian: 'pachistano', english: 'Pakistani', emoji: '🇵🇰' },
        { italian: 'nigeriano', english: 'Nigerian', emoji: '🇳🇬' },
        { italian: 'marocchino', english: 'Moroccan', emoji: '🇲🇦' },
      ],
    },
  
    // ══════════════════════════════════════════════════════════════════════
    // A1 LIVELLO 3: FAMIGLIA
    // ══════════════════════════════════════════════════════════════════════
  
    {
      slug: 'famiglia',
      name: 'La Famiglia',
      emoji: '👨‍👩‍👧',
      words: [
        { italian: 'i genitori', english: 'parents', emoji: '👨‍👩‍👧' },
        { italian: 'la madre / la mamma', english: 'mother / mom', emoji: '👩' },
        { italian: 'il padre / il papà / il babbo', english: 'father / dad', emoji: '👨' },
        { italian: 'il fratello', english: 'brother', emoji: '👦' },
        { italian: 'la sorella', english: 'sister', emoji: '👧' },
        { italian: 'il marito', english: 'husband', emoji: '🤵' },
        { italian: 'la moglie', english: 'wife', emoji: '👰' },
        { italian: 'il figlio', english: 'son', emoji: '👦' },
        { italian: 'la figlia', english: 'daughter', emoji: '👧' },
        { italian: 'il nonno', english: 'grandfather', emoji: '👴' },
        { italian: 'la nonna', english: 'grandmother', emoji: '👵' },
        { italian: 'la bisnonna', english: 'great-grandmother', emoji: '👵' },
        { italian: 'il bisnonno', english: 'great-grandfather', emoji: '👴' },
        { italian: 'lo zio', english: 'uncle', emoji: '👨' },
        { italian: 'la zia', english: 'aunt', emoji: '👩' },
        { italian: 'il cugino / la cugina', english: 'cousin', emoji: '🧑' },
        { italian: 'il cognato', english: 'brother in law' },
        { italian: 'la cognata', english: 'sister in law' },
        { italian: 'il/la nipote', english: 'nephew / niece / grandchild', emoji: '🧒' },
        { italian: 'il fidanzato / la fidanzata', english: 'boyfriend / girlfriend', emoji: '💑' },
        { italian: 'il compagno / la compagna', english: 'partner', emoji: '🤝' },
        { italian: 'il gemello / la gemella', english: 'twin', emoji: '👯' },
        { italian: 'il figlio unico', english: 'only child', emoji: '👦' },
        { italian: 'i suoceri', english: 'in-laws', emoji: '👴👵' },
        { italian: 'il suocero', english: 'father-in-law', emoji: '👴' },
        { italian: 'la suocera', english: 'mother-in-law', emoji: '👵' },
        { italian: 'il patrigno', english: 'stepfather', emoji: '👨' },
        { italian: 'la matrigna', english: 'stepmother', emoji: '👩' },
        { italian: 'il fratellastro', english: 'stepbrother', emoji: '👦' },
        { italian: 'la sorellastra', english: 'stepsister', emoji: '👧' },
        { italian: 'adottato', english: 'adopted', emoji: '❤️' },
      ],
    },
  
    // ══════════════════════════════════════════════════════════════════════
    // A1 LIVELLO 4: TEMPO LIBERO
    // ══════════════════════════════════════════════════════════════════════
  
    // {
    //   slug: 'meteo',
    //   name: 'Il Meteo',
    //   emoji: '☀️',
    //   words: [
    //     { italian: "l'ombrello", english: 'umbrella', emoji: '☂️' },
    //     { italian: 'il lampo / il fulmine', english: 'lightning', emoji: '⚡' },
    //     { italian: 'il sole', english: 'sun', emoji: '☀️' },
    //     { italian: 'la pioggia', english: 'rain', emoji: '🌧️' },
    //     { italian: 'la neve', english: 'snow', emoji: '❄️' },
    //     { italian: 'il vento', english: 'wind', emoji: '💨' },
    //     { italian: 'la rugiada', english: 'dew', emoji: '💧' },
    //     { italian: 'la nuvola', english: 'cloud', emoji: '☁️' },
    //     { italian: 'il temporale', english: 'storm', emoji: '⛈️' },
    //     { italian: 'i tuoni', english: 'thunder', emoji: '🌩️' },
    //     { italian: 'la nebbia', english: 'fog / mist', emoji: '🌫️' },
    //     { italian: 'la grandine', english: 'hail', emoji: '🌨️' },
    //     { italian: "l'arcobaleno", english: 'rainbow', emoji: '🌈' },
    //     { italian: 'nuvoloso', english: 'cloudy', emoji: '☁️' },
    //     { italian: 'soleggiato', english: 'sunny', emoji: '☀️' },
    //     { italian: 'ventoso', english: 'windy', emoji: '💨' },
    //     { italian: 'piovoso', english: 'rainy', emoji: '🌧️' },
    //     { italian: 'fa freddo', english: "it's cold", emoji: '🥶' },
    //     { italian: 'fa caldo', english: "it's hot", emoji: '🥵' },
    //     { italian: 'fa bello', english: "it's nice (weather)", emoji: '😊' },
    //     { italian: 'nevicare', english: 'to snow', emoji: '❄️' },
    //     { italian: 'piovere', english: 'to rain', emoji: '🌧️' },
    //     { italian: 'la tormenta', english: 'thunderstorm', emoji: '⛈️' },
    //     { italian: "la tromba d'aria", english: 'whirlwind', emoji: '🌪️' },
    //     { italian: 'il tornado', english: 'tornado', emoji: '🌪️' },
    //     { italian: 'il gelo', english: 'frost', emoji: '🧊' },
    //     { italian: 'la pozzanghera', english: 'puddle', emoji: '💧' },
    //     { italian: 'il ghiaccio', english: 'ice', emoji: '🧊' },
    //     { italian: 'la valanga', english: 'avalanche', emoji: '🏔️' },
    //     { italian: 'l\'alluvione', english: 'flood', emoji: '🌊' },
    //     { italian: 'la siccità', english: 'drought', emoji: '🏜️' },
    //     { italian: 'afoso', english: 'humid / muggy', emoji: '💧' },
    //     { italian: 'sereno', english: 'clear / sunny', emoji: '☀️' },
    //     { italian: 'le previsioni del tempo', english: 'weather forecast', emoji: '📺' },
    //     { italian: 'il termometro', english: 'thermometer', emoji: '🌡️' },
    //     { italian: 'gradi', english: 'degrees', emoji: '🌡️' },
    //   ],
    // },
  {
  slug: 'meteo',
  name: 'Il Meteo',
  emoji: '☀️',
  words: [
    // --- Domande principali / Key questions ---
    { italian: "Che tempo fa? / Com'è il tempo?", english: "What's the weather like?", options: ["How many degrees it it?", "What time is it?", "Is it sunny?"]  },
    { italian: 'Quanti gradi ci sono?', english: 'How many degrees is it?', options: ["How are you?", "What time is it?", "What's the weather like?"]  },
 
    // --- Vocabolario generale / General weather vocab ---
    { italian: 'il sole', english: 'sun', emoji: '☀️', options: ["rain", "cloud", "moon"] },
    { italian: 'la pioggia', english: 'rain', emoji: '🌧️', options: ["snow", "sun", "wind"] },
    { italian: 'la neve', english: 'snow', emoji: '❄️', options: ["rain", "hail", "ice"] },
    { italian: 'il vento', english: 'wind', emoji: '💨', options: ["storm", "cloud", "fog"] },
    { italian: 'la nuvola', english: 'cloud', emoji: '☁️', options: ["fog", "sky", "storm"] },
    { italian: 'il temporale', english: 'storm', emoji: '⛈️', options: ["rain", "wind", "cloud"] },
    { italian: 'il tuono', english: 'thunder', emoji: '🌩️', options: ["lightning", "rain", "wind"] },
    { italian: 'il lampo / il fulmine', english: 'lightning', emoji: '⚡', options: ["thunder", "storm", "rainbow"] },
    { italian: 'la nebbia', english: 'fog / mist', emoji: '🌫️', options: ["haze", "cloud", "smoke"] },
    { italian: 'la foschia', english: 'haze', emoji: '🌫️', options: ["fog", "smoke", "dew"] },
    { italian: 'la grandine', english: 'hail', emoji: '🌨️', options: ["snow", "frost", "sleet"] },
    { italian: "l'arcobaleno", english: 'rainbow', emoji: '🌈', options: ["sunset", "lightning", "cloud"] },
    { italian: 'la rugiada', english: 'dew', emoji: '💧', options: ["frost", "puddle", "ice"] },
    { italian: 'il gelo', english: 'frost', emoji: '🧊', options: ["dew", "ice", "snow"] },
    { italian: 'il ghiaccio', english: 'ice', emoji: '🧊', options: ["frost", "snow", "hail"] },
    { italian: 'la pozzanghera', english: 'puddle', emoji: '💧', options: ["lake", "river", "dew"] },
    { italian: 'la tormenta', english: 'snowstorm', emoji: '🌨️', options: ["hailstorm", "thunderstorm", "drought"] },
    { italian: "la tromba d'aria / il tornado", english: 'tornado', emoji: '🌪️', options: ["hurricane", "avalanche", "flood"] },
    { italian: 'la valanga', english: 'avalanche', emoji: '🏔️', options: ["tornado", "flood", "drought"] },
    { italian: "l'alluvione", english: 'flood', emoji: '🌊', options: ["drought", "avalanche", "storm"] },
    { italian: 'la siccità', english: 'drought', emoji: '🏜️', options: ["flood", "frost", "fog"] },
    { italian: "l'ombrello", english: 'umbrella', emoji: '☂️', options: ["raincoat", "boots", "hat"] },
    { italian: 'le previsioni del tempo', english: 'weather forecast', emoji: '📺', options: ["once upon a time", "it's time to go", "only one time"]  },
    { italian: 'il termometro', english: 'thermometer', emoji: '🌡️', options: ["barometer", "clock", "calendar"] },
    { italian: 'i gradi', english: 'degrees', emoji: '🌡️', options: ["minutes", "hours", "percent"] },
 
    // --- 1. FA + AGGETTIVO (descrizione generale) ---
    { italian: 'fa caldo', english: "it's hot", emoji: '☀️', options: ["it's cold", "it's dry", "it's overcast"] },
    { italian: 'fa molto caldo / fa caldissimo', english: "it's very hot", emoji: '🥵', options: ["it's freezing cold", "it's rainy", "it's humid"] },
    { italian: 'fa un caldo torrido', english: "it's scorching hot", emoji: '🔥', options: ["it's freezing cold", "it's warm", "it's overcast"] },
    { italian: 'fa freddo', english: "it's cold", emoji: '❄️', options: ["it's hot", "it's rainy", "it's cloudy"] },
    { italian: 'fa molto freddo / fa freddissimo', english: "it's very cold", emoji: '🥶', options: ["it's warm", "it's very hot", "it's cold"] },
    { italian: 'fa un freddo cane', english: "it's freezing cold (idiom)", emoji: '🧊', options: ["it's windy", "it's humid", "it's dry"] },
    { italian: 'fa fresco', english: "it's cool (pleasant)", emoji: '🙂', options: ["it's cold", "it's sunny", "it's cloudy"]},
    { italian: 'fa brutto', english: 'the weather is bad', emoji: '🌧️', options: ["the weather is nice", "it's dry", "it's muggy"] },
    { italian: 'fa bel tempo', english: 'the weather is nice', emoji: '😊', options: ["the weather is bad", "it's dry", "it's muggy"] },
 
    // --- 2. È + AGGETTIVO (descrizione specifica) ---
// --- 2. È + AGGETTIVO (descrizione specifica) ---
    { italian: 'è nuvoloso', english: "it's cloudy", emoji: '☁️', options: ["it's sunny", "it's dry", "it's windy"] },
    { italian: 'è molto nuvoloso', english: "it's very cloudy", emoji: '☁️', options: ["it's a bit cloudy", "it's clear", "it's foggy"] },
    { italian: 'è coperto', english: "it's overcast", emoji: '☁️', options: ["it's clear", "it's sunny", "it's windy"] },
    { italian: 'è piovoso', english: "it's rainy", emoji: '🌧️', options: ["it's snowy", "it's sunny", "it's dry"] },
    { italian: 'è ventoso', english: "it's windy", emoji: '💨', options: ["it's calm", "it's humid", "it's foggy"] },
    { italian: 'è soleggiato', english: "it's sunny", emoji: '☀️', options: ["it's cloudy", "it's rainy", "it's overcast"] },
    { italian: 'è sereno', english: "it's clear (cloudless)", emoji: '🌤️', options: ["it's cloudy", "it's stormy", "it's foggy"] },
    { italian: 'è instabile', english: 'the weather is unpredictable', emoji: '🌦️', options: ["the weather is stable", "it's clear", "it's sunny"] },
    { italian: 'è umido', english: "it's humid", emoji: '💧', options: ["it's dry", "it's cold", "it's windy"] },
    { italian: 'è secco', english: "it's dry", emoji: '🏜️', options: ["it's humid", "it's rainy", "it's foggy"] },
    { italian: 'è afoso', english: "it's hot and humid, muggy", emoji: '🥵', options: ["it's cool", "it's dry", "it's freezing"] },

    // --- IL CIELO è... / The sky is... ---
    { italian: 'il cielo è stellato', english: 'the sky is starry', emoji: '✨', options: ["the sky is cloudy", "the sky is grey", "the sky is blue"] },
    { italian: 'il cielo è grigio', english: 'the sky is grey', emoji: '☁️', options: ["the sky is cloudy", "the sky is starry", "the sky is blue"] },
    { italian: 'il cielo è azzurro', english: 'the sky is blue', emoji: '🏙️', options: ["the sky is grey", "the sky is starry", "the sky is cloudy"] },
 
    // --- 3. C'È + NOME ---
{ italian: "c'è il sole", english: 'there is sun', emoji: '☀️', options: ["there is rain", "there is snow", "there is fog"] },
    { italian: "c'è la neve", english: 'there is snow', emoji: '❄️', options: ["there is rain", "there is sun", "there is hail"] },
    { italian: "c'è un temporale", english: 'there is a storm', emoji: '⛈️', options: ["there is a rainbow", "there is fog", "there is sun"] },
    { italian: "c'è vento", english: 'there is wind', emoji: '💨', options: ["there is rain", "there is a storm", "there is fog"] },
    { italian: "c'è una brezza", english: 'there is a light breeze', emoji: '🍃', options: ["there is a storm", "there is a strong wind", "there is fog"] },
    { italian: "c'è umidità", english: 'there is humidity', emoji: '💧', options: ["there is drought", "there is frost", "there is snow"] },
    { italian: "c'è un arcobaleno", english: 'there is a rainbow', emoji: '🌈', options: ["there is lightning", "there is a storm", "there is fog"] },
    { italian: "c'è un'alluvione", english: 'there is a flood', emoji: '🌊', options: ["there is a drought", "there is an avalanche", "there is a storm"] },
 
    // --- 4. C'È / CI SONO + GRADI ---
{ italian: "c'è un grado", english: "it's one degree", emoji: '🌡️', options: ["it's ten degrees", "it's zero degrees", "it's below zero"] },
    { italian: 'ci sono 0 gradi', english: "it's 0 degrees", emoji: '🌡️', options: ["it's 1 degree", "it's 10 degrees", "it's below zero"] },
    { italian: 'ci sono 30 gradi', english: "it's 30 degrees", emoji: '🌡️', options: ["it's 3 degrees", "it's 0 degrees", "it's 13 degrees"] },
    { italian: 'ci sono 5 gradi sotto zero', english: "it's 5 degrees below zero", emoji: '🌡️', options: ["it's 5.0 degrees", "it's 5 degrees above zero", "it's 0 or 5 degrees"] },
    { italian: 'sotto zero', english: 'below zero', emoji: '🥶', options: ["above zero", "at zero", "very hot"] },
 
    // --- 5. VERBI IMPERSONALI ---
{ italian: 'piovere', english: 'to rain', emoji: '🌧️', options: ["to snow", "to be windy", "to be sunny"] },
    { italian: 'pioviggiare', english: 'to drizzle', emoji: '🌦️', options: ["to pour rain", "to hail", "to snow"] },
    { italian: 'nevicare', english: 'to snow', emoji: '❄️', options: ["to rain", "to hail", "to freeze"] },
    { italian: 'grandinare', english: 'to hail', emoji: '🌨️', options: ["to snow", "to rain", "to thunder"] },
    { italian: 'tuonare', english: 'to thunder', emoji: '🌩️', options: ["to rain", "to flash (lightning)", "to snow"] },
  ],
},

    {
  slug: 'passatempi',
  name: 'I Passatempi',
  emoji: '🎯',
  words: [
    { italian: 'ascoltare musica', english: 'to listen to music', emoji: '🎵', options: ["to play an instrument", "to sing", "to dance"] },
    { italian: 'correre', english: 'to run', emoji: '🏃', options: ["to take a walk", "to swim", "to go for a bike ride"] },
    { italian: 'cucinare', english: 'to cook', emoji: '👨‍🍳', options: ["to clean the house", "to go shopping", "to do gardening"] },
    { italian: 'dipingere', english: 'to paint', emoji: '🎨', options: ["to draw", "to write a poem", "to take photos"] },
    { italian: 'disegnare', english: 'to draw', emoji: '✏️', options: ["to paint", "to take photos", "to write a poem"] },
    { italian: 'dormire', english: 'to sleep', emoji: '😴', options: ["to meditate", "to do yoga", "to watch TV"] },
    { italian: 'giocare a calcio', english: 'to play soccer', emoji: '⚽', options: ["to play tennis", "to play video games", "to go to the gym"] },
    { italian: 'giocare a tennis', english: 'to play tennis', emoji: '🎾', options: ["to play soccer", "to play video games", "to do aerobics"] },
    { italian: 'giocare ai videogiochi', english: 'to play video games', emoji: '🎮', options: ["to play soccer", "to play tennis", "to watch TV"] },
    { italian: 'guardare un film', english: 'to watch a film', emoji: '🎬', options: ["to watch TV", "to read a book", "to listen to music"] },
    { italian: 'guardare la televisione', english: 'to watch TV', emoji: '📺', options: ["to watch a film", "to read a book", "to listen to music"] },
    { italian: 'leggere un libro', english: 'to read a book', emoji: '📚', options: ["to write a poem", "to watch a film", "to draw"] },
    { italian: 'suonare uno strumento', english: 'to play an instrument', emoji: '🎸', options: ["to sing", "to listen to music", "to dance"] },
    { italian: 'uscire con gli amici', english: 'to go out with friends', emoji: '👫', options: ["to take a walk", "to go shopping", "to travel"] },
    { italian: 'viaggiare', english: 'to travel', emoji: '✈️', options: ["to go for a bike ride", "to go out with friends", "to take a walk"] },
    { italian: 'andare in palestra', english: 'to go to the gym', emoji: '🏋️', options: ["to do aerobics", "to do yoga", "to run"] },
    { italian: 'fare una passeggiata', english: 'to take a walk', emoji: '🚶', options: ["to run", "to go for a bike ride", "to travel"] },
    { italian: 'fare aerobica', english: 'to do aerobics', emoji: '🤸', options: ["to do yoga", "to go to the gym", "to swim"] },
    { italian: 'fare un giro in bici / fare un giro in macchina / fare un giro a piedi', english: 'to go for a bike ride / to go for a car ride / to go for a walk', emoji: '🚲', options: ["to take a walk", "to run", "to travel"] },
    { italian: 'scrivere una poesia', english: 'to write a poem', emoji: '✍️', options: ["to read a book", "to draw", "to paint"] },
    { italian: 'pulire la casa', english: 'to clean the house', emoji: '🧹', options: ["to do gardening", "to cook", "to go shopping"] },
    { italian: 'fare yoga', english: 'to do yoga', emoji: '🧘', options: ["to meditate", "to do aerobics", "to sleep"] },
    { italian: 'fare fotografie', english: 'to take photos', emoji: '📸', options: ["to paint", "to draw", "to collect"] },
    { italian: 'fare il giardinaggio', english: 'to do gardening', emoji: '🌱', options: ["to clean the house", "to volunteer", "to cook"] },
    { italian: 'fare shopping', english: 'to go shopping', emoji: '🛍️', options: ["to go out with friends", "to travel", "to collect"] },
    { italian: 'ballare', english: 'to dance', emoji: '💃', options: ["to sing", "to play an instrument", "to do aerobics"] },
    { italian: 'cantare', english: 'to sing', emoji: '🎤', options: ["to dance", "to play an instrument", "to listen to music"] },
    { italian: 'nuotare', english: 'to swim', emoji: '🏊', options: ["to run", "to do aerobics", "to go for a bike ride"] },
    { italian: 'meditare', english: 'to meditate', emoji: '🧘', options: ["to do yoga", "to sleep", "to take a walk"] },
    { italian: 'collezionare', english: 'to collect', emoji: '📦', options: ["to take photos", "to go shopping", "to volunteer"] },
    { italian: 'fare volontariato', english: 'to volunteer', emoji: '🤝', options: ["to do gardening", "to collect", "to clean the house"] },
    { italian: 'costoso', english: 'expensive', emoji: '💸', options: ["difficult", "dangerous", "intensive"] },
    { italian: 'difficile', english: 'difficult', emoji: '😓', options: ["expensive", "dangerous", "intensive"] },
    { italian: 'divertente', english: 'fun', emoji: '😄', options: ["relaxing", "intensive", "solo"] },
    { italian: 'gioco di squadra', english: 'team game', emoji: '🤝', options: ["solo", "relaxing", "intensive"] },
    { italian: 'intenso', english: 'intensive', emoji: '💪', options: ["fast", "difficult", "dangerous"] },
    { italian: 'lento', english: 'slow', emoji: '🐢', options: ["fast", "relaxing", "intensive"] },
    { italian: 'pericoloso', english: 'dangerous', emoji: '⚠️', options: ["difficult", "intensive", "expensive"] },
    { italian: 'rilassante', english: 'relaxing', emoji: '😌', options: ["fun", "slow", "solo"] },
    { italian: 'solitario', english: 'solo', emoji: '🧘', options: ["team game", "relaxing", "fun"] },
    { italian: 'veloce', english: 'fast', emoji: '🐇', options: ["slow", "intensive", "dangerous"] },
  ],
},

{
  slug: 'sport',
  name: 'Gli Sport',
  emoji: '🏅',
  words: [
    { italian: 'il calcio', english: 'football / soccer', emoji: '⚽', options: ["rugby", "american football", "baseball"] },
    { italian: 'il nuoto', english: 'swimming', emoji: '🏊', options: ["triathlon", "rowing", "surfing"] },
    { italian: 'il ciclismo', english: 'cycling', emoji: '🚲', options: ["jogging", "cross country running", "marathon"] },
    { italian: "l'alpinismo", english: 'mountain climbing', emoji: '🧗', options: ["rock climbing", "skydiving", "hang gliding"] },
    { italian: "l'equitazione", english: 'horse riding', emoji: '🏇', options: ["cycling", "sailing", "golf"] },
    { italian: 'il judo', english: 'judo', emoji: '🥋', options: ["karate", "taekwondo", "wrestling"] },
    { italian: 'il jogging', english: 'jogging', emoji: '🏃', options: ["cross country running", "marathon", "cycling"] },
    { italian: 'il ping-pong', english: 'table tennis', emoji: '🏓', options: ["tennis", "padel", "golf"] },
    { italian: 'il pattinaggio sul ghiaccio', english: 'ice skating', emoji: '⛸️', options: ["skiing", "snowboard", "hang gliding"] },
    { italian: 'lo sci', english: 'skiing', emoji: '⛷️', options: ["snowboard", "ice skating", "hang gliding"] },
    { italian: 'il volo libero', english: 'hang gliding', emoji: '🪂', options: ["skydiving", "mountain climbing", "surfing"] },
    { italian: "il tiro con l'arco", english: 'archery', emoji: '🏹', options: ["clay pigeon shooting", "golf", "boxing"] },
    { italian: 'la pallacanestro / il basket', english: 'basketball', emoji: '🏀', options: ["baseball", "rugby", "american football"] },
    { italian: 'il sumo', english: 'sumo wrestling', emoji: '🤼', options: ["wrestling", "judo", "boxing"] },
    { italian: 'i pattini', english: 'ice skates', emoji: '⛸️', options: ["helmet", "locker", "ski lift / chairlift"] },
    { italian: 'il casco', english: 'helmet', emoji: '⛑️', options: ["ice skates", "locker", "ski lift / chairlift"] },
    { italian: 'la seggiovia', english: 'ski lift / chairlift', emoji: '🚡', options: ["changing room", "locker", "ice skates"] },
    { italian: 'lo spogliatoio', english: 'changing room', emoji: '🚿', options: ["locker", "ski lift / chairlift", "helmet"] },
    { italian: "l'armadietto", english: 'locker', emoji: '🔒', options: ["changing room", "ski lift / chairlift", "ice skates"] },
    { italian: 'lo snowboard', english: 'snowboard', emoji: '🏂', options: ["skiing", "ice skating", "hang gliding"] },
    { italian: 'la vela', english: 'sailing', emoji: '⛵', options: ["windsurfing", "surfing", "fishing"] },
    { italian: 'il baseball', english: 'baseball', emoji: '⚾', options: ["american football", "rugby", "basketball"] },
    { italian: 'il football americano', english: 'american football', emoji: '🏈', options: ["rugby", "baseball", "football / soccer"] },
    { italian: 'il tennis', english: 'tennis', emoji: '🎾', options: ["padel", "table tennis", "golf"] },
    { italian: 'la pesca', english: 'fishing', emoji: '🎣', options: ["sailing", "rowing", "windsurfing"] },
    { italian: 'il rugby', english: 'rugby', emoji: '🏉', options: ["american football", "football / soccer", "baseball"] },
    { italian: 'la corsa campestre', english: 'cross country running', emoji: '🏃', options: ["jogging", "marathon", "cycling"] },
    { italian: 'la danza', english: 'dancing', emoji: '💃', options: ["artistic gymnastics", "ice skating", "karate"] },
    { italian: 'la ginnastica artistica', english: 'artistic gymnastics', emoji: '🤸', options: ["dancing", "judo", "karate"] },
    { italian: 'la gara', english: 'competition', emoji: '🏆', options: ["game", "tournament", "championship"] },
    { italian: 'il giocatore / la giocatrice', english: 'player', emoji: '👤', options: ["referee", "fan / supporter", "team"] },
    { italian: 'la palla', english: 'ball', emoji: '⚽', options: ["goal", "helmet", "ice skates"] },
    { italian: 'la partita', english: 'game', emoji: '🎮', options: ["competition", "tournament", "championship"] },
    { italian: 'la squadra', english: 'team', emoji: '👥', options: ["player", "fan / supporter", "game"] },
    { italian: 'vincere', english: 'to win', emoji: '🏆', options: ["to lose", "draw / tie", "to cheer"] },
    { italian: 'perdere', english: 'to lose', emoji: '😔', options: ["to win", "draw / tie", "to cheer"] },
    { italian: 'il padel', english: 'padel', emoji: '🎾', options: ["tennis", "table tennis", "golf"] },
    { italian: 'il golf', english: 'golf', emoji: '⛳', options: ["padel", "tennis", "archery"] },
    { italian: 'il pugilato', english: 'boxing', emoji: '🥊', options: ["wrestling", "karate", "sumo wrestling"] },
    { italian: 'la lotta libera', english: 'wrestling', emoji: '🤼', options: ["sumo wrestling", "boxing", "judo"] },
    { italian: 'il karate', english: 'karate', emoji: '🥋', options: ["taekwondo", "judo", "wrestling"] },
    { italian: 'il taekwondo', english: 'taekwondo', emoji: '🥋', options: ["karate", "judo", "boxing"] },
    { italian: 'il triathlon', english: 'triathlon', emoji: '🏊', options: ["marathon", "swimming", "cycling"] },
    { italian: 'la maratona', english: 'marathon', emoji: '🏃', options: ["cross country running", "triathlon", "jogging"] },
    { italian: 'il tiro a volo', english: 'clay pigeon shooting', emoji: '🎯', options: ["archery", "fishing", "golf"] },
    { italian: 'il canottaggio', english: 'rowing', emoji: '🚣', options: ["sailing", "windsurfing", "swimming"] },
    { italian: 'il surf', english: 'surfing', emoji: '🏄', options: ["windsurfing", "sailing", "rowing"] },
    { italian: 'il windsurf', english: 'windsurfing', emoji: '🏄', options: ["surfing", "sailing", "rowing"] },
    { italian: "l'arrampicata", english: 'rock climbing', emoji: '🧗', options: ["mountain climbing", "skydiving", "hang gliding"] },
    { italian: 'il paracadutismo', english: 'skydiving', emoji: '🪂', options: ["hang gliding", "rock climbing", "mountain climbing"] },
    { italian: "l'allenamento", english: 'training / workout', emoji: '💪', options: ["competition", "championship", "tournament"] },
    { italian: 'il campionato', english: 'championship', emoji: '🏆', options: ["tournament", "competition", "game"] },
    { italian: 'il torneo', english: 'tournament', emoji: '🏆', options: ["championship", "competition", "game"] },
    { italian: "l'arbitro", english: 'referee', emoji: '👮', options: ["fan / supporter", "player", "team"] },
    { italian: 'il tifoso / la tifosa', english: 'fan / supporter', emoji: '📣', options: ["referee", "player", "team"] },
    { italian: 'fare il tifo', english: 'to cheer', emoji: '📣', options: ["to win", "to lose", "fan / supporter"] },
    { italian: 'il pareggio', english: 'draw / tie', emoji: '🤝', options: ["goal", "penalty", "game"] },
    { italian: 'il gol', english: 'goal', emoji: '⚽', options: ["penalty", "draw / tie", "ball"] },
    { italian: 'il rigore', english: 'penalty', emoji: '⚽', options: ["goal", "draw / tie", "ball"] },
  ],
},
  
    // ══════════════════════════════════════════════════════════════════════
    // A2 LIVELLO 5: IERI E OGGI
    // ══════════════════════════════════════════════════════════════════════
  
    {
      slug: 'colazione_bar',
      name: 'La Colazione e Il Bar',
      emoji: '☕',
      words: [
        { italian: "l'arancia", english: 'orange', emoji: '🍊' },
        { italian: "il caffè", english: 'coffee', emoji: '☕' },
        { italian: 'il cappuccino', english: 'cappuccino', emoji: '☕' },
        { italian: "l'espresso", english: 'espresso', emoji: '☕' },
        { italian: 'la fetta di limone', english: 'lemon slice', emoji: '🍋' },
        { italian: 'la fetta di pane', english: 'bread slice', emoji: '🍞' },
        { italian: "la spremuta d'arancia", english: 'freshly squeezed OJ', emoji: '🍊' },
        { italian: 'il tè caldo', english: 'a hot tea', emoji: '🍵' },
        { italian: "l'uovo sodo", english: 'hard-boiled egg', emoji: '🥚' },
        { italian: "l'uovo fritto", english: 'fried egg', emoji: '🍳' },
        { italian: 'il pane tostato', english: 'toast', emoji: '🍞' },
        { italian: 'la marmellata', english: 'marmalade', emoji: '🍓' },
        { italian: 'i cereali', english: 'cereal', emoji: '🥣' },
        { italian: 'la cioccolata calda', english: 'hot chocolate', emoji: '🍫' },
        { italian: 'il latte', english: 'milk', emoji: '🥛' },
        { italian: 'il cornetto', english: 'croissant', emoji: '🥐' },
        { italian: 'il miele', english: 'honey', emoji: '🍯' },
        { italian: 'la pasta', english: 'pastry', emoji: '🥐' },
        { italian: 'lo zucchero', english: 'sugar', emoji: '🍬' },
        { italian: 'il prosciutto', english: 'ham / prosciutto', emoji: '🥩' },
        { italian: 'la frittata', english: 'omelette / frittata', emoji: '🍳' },
        { italian: 'il burro', english: 'butter', emoji: '🧈' },
        { italian: "l'acqua naturale", english: 'still water', emoji: '💧' },
        { italian: "l'acqua frizzante", english: 'sparkling water', emoji: '🫧' },
        { italian: 'il barista', english: 'barista', emoji: '👨‍🍳' },
        { italian: 'lo scontrino', english: 'receipt', emoji: '🧾' },
        { italian: 'la cassa', english: 'cashier', emoji: '💰' },
        { italian: 'il resto', english: 'change', emoji: '💰' },
        { italian: 'il burro di arachidi', english: 'peanut butter', emoji: '🥜' },
      ],
    },
  
    {
      slug: 'professioni',
      name: 'Le Professioni',
      emoji: '💼',
      words: [
        { italian: "l'architetto", english: 'architect', emoji: '🏗️' },
        { italian: "l'attore / l'attrice", english: 'actor / actress', emoji: '🎭' },
        { italian: 'il/la barista', english: 'barman / barmaid', emoji: '🍸' },
        { italian: 'il cameriere / la cameriera', english: 'waiter / waitress', emoji: '🍽️' },
        { italian: 'il commesso / la commessa', english: 'shop assistant', emoji: '🛍️' },
        { italian: 'il cuoco / la cuoca', english: 'cook', emoji: '👨‍🍳' },
        { italian: 'il dottore / la dottoressa', english: 'doctor', emoji: '👨‍⚕️' },
        { italian: 'il/la farmacista', english: 'pharmacist', emoji: '💊' },
        { italian: 'il/la giornalista', english: 'journalist', emoji: '📰' },
        { italian: "l'infermiere / l'infermiera", english: 'nurse', emoji: '👩‍⚕️' },
        { italian: "l'ingegnere", english: 'engineer', emoji: '⚙️' },
        { italian: "l'insegnante", english: 'teacher', emoji: '👩‍🏫' },
        { italian: 'il meccanico', english: 'mechanic', emoji: '🔧' },
        { italian: 'il muratore', english: 'builder', emoji: '🏗️' },
        { italian: 'il/la pilota', english: 'pilot', emoji: '✈️' },
        { italian: 'il professore / la professoressa', english: 'professor', emoji: '👨‍🏫' },
        { italian: 'lo scrittore / la scrittrice', english: 'writer', emoji: '✍️' },
        { italian: 'lo studente / la studentessa', english: 'student', emoji: '🎓' },
        { italian: 'il vigile del fuoco', english: 'firefighter', emoji: '🚒' },
        { italian: 'il veterinario', english: 'vet', emoji: '🐾' },
        { italian: 'il poliziotto / la poliziotta', english: 'police officer', emoji: '👮' },
        { italian: 'il/la cantante', english: 'singer', emoji: '🎤' },
        { italian: 'il ballerino / la ballerina', english: 'dancer', emoji: '💃' },
        { italian: "l'idraulico", english: 'plumber', emoji: '🔧' },
        { italian: 'il parrucchiere / la parrucchiera', english: 'hairdresser', emoji: '💇' },
        { italian: 'il camionista / la camionista', english: 'truck driver', emoji: '🚛' },
        { italian: 'il postino', english: 'postman', emoji: '📬' },
        { italian: 'il dentista / la dentista', english: 'dentist', emoji: '🦷' },
        { italian: "l'imbianchino", english: 'painter / decorator', emoji: '🎨' },
        { italian: 'il panettiere / la panettiera', english: 'baker', emoji: '🥖' },
        { italian: 'il subacqueo', english: 'diver', emoji: '🤿' },
        { italian: 'il pescivendolo / la pescivendola', english: "fishmonger's", emoji: '🐟' },
        { italian: 'il salumiere / la salumiera', english: 'deli owner', emoji: '🥩' },
        { italian: 'il macellaio', english: 'butcher', emoji: '🥩' },
        { italian: 'il pasticcere / la pasticcera', english: 'pastry chef', emoji: '🍰' },
        { italian: 'il giudice', english: 'judge', emoji: '⚖️' },
        { italian: 'il/la manager', english: 'manager', emoji: '👔' },
        { italian: 'il/la receptionist', english: 'receptionist', emoji: '🏨' },
        { italian: 'il/la personal trainer', english: 'personal trainer', emoji: '🏋️' },
        { italian: 'il/la fotografo/a', english: 'photographer', emoji: '📸' },
        { italian: 'il/la designer', english: 'designer', emoji: '🎨' },
        { italian: 'il/la programmatore/trice', english: 'programmer', emoji: '💻' },
        { italian: 'il/la traduttore/trice', english: 'translator', emoji: '🌍' },
        { italian: 'il/la psicologo/a', english: 'psychologist', emoji: '🧠' },
        { italian: 'il/la fisioterapista', english: 'physiotherapist', emoji: '💪' },
        { italian: 'il/la contabile', english: 'accountant', emoji: '📊' },
        { italian: 'il/la avvocato/essa', english: 'lawyer', emoji: '⚖️' },
        { italian: 'il/la politico/a', english: 'politician', emoji: '🏛️' },
        { italian: 'il/la scienziato/a', english: 'scientist', emoji: '🔬' },
        { italian: 'il/la astronauta', english: 'astronaut', emoji: '👨‍🚀' },
        { italian: 'il/la atleta', english: 'athlete', emoji: '🏅' },
        { italian: 'il/la cuoco/a di casa', english: 'home cook', emoji: '👨‍🍳' },
        { italian: 'il/la casalingo/a', english: 'housewife / househusband', emoji: '🏠' },
        { italian: 'il/la volontario/a', english: 'volunteer', emoji: '🤝' },
      ],
    },
  
    // ══════════════════════════════════════════════════════════════════════
    // A2 LIVELLO 6: SAPORI E RICORDI
    // ══════════════════════════════════════════════════════════════════════
  
    {
      slug: 'ristorante',
      name: 'Il Ristorante',
      emoji: '🍝',
      words: [
        { italian: 'pagare in contanti', english: 'to pay with cash', emoji: '💵' },
        { italian: 'pagare con la carta', english: 'to pay with card', emoji: '💳' },
        { italian: 'lasciare la mancia', english: 'to leave a tip', emoji: '💰' },
        { italian: 'prenotare un tavolo', english: 'to reserve a table', emoji: '📞' },
        { italian: "una bottiglia di", english: "a bottle of", emoji: '🍾' },
        { italian: "un bicchiere di", english: "a glass of", emoji: '🍷' },
        { italian: 'il vino della casa', english: 'house wine', emoji: '🍷' },
        { italian: "l'acqua naturale", english: "still water", emoji: '💧' },
        { italian: "l'acqua frizzante", english: "sparkling water", emoji: '🫧' },
        { italian: 'la specialità della casa', english: 'house specialty', emoji: '⭐' },        
        { italian: 'fatto in casa', english: 'homemade', emoji: '🏠' },
        { italian: 'vorrei', english: "I'd like", emoji: '🙋' },
        { italian: 'il conto', english: 'the bill', emoji: '🧾' },
        { italian: 'il menù', english: 'menu', emoji: '📋' },
        { italian: 'il cameriere / la cameriera', english: 'waiter / waitress', emoji: '🍽️' },
        { italian: 'il tavolo', english: 'table', emoji: '🪑' },
        { italian: 'il coperto', english: 'cover charge', emoji: '💰' },
        { italian: 'il menù del giorno', english: 'daily menu', emoji: '📋' },
        { italian: 'senza glutine', english: 'gluten free', emoji: '🌾' },
        { italian: 'celiaco', english: 'celiac', emoji: '🌾' },
        { italian: 'vegetariano', english: 'vegetarian', emoji: '🥗' },
        {italian:  'vegano', english:'vegan', emoji: '🥗'},
        { italian: 'allergico/a a', english: "I'm allergic to", emoji: '⚠️' },
        {italian: 'intollerante al lattosio', english:"lactose intolerant", emoji: '🥛' },
        { italian: 'la lista dei vini', english: 'wine list', emoji: '🍷' },
        { italian: 'al dente', english: 'al dente', emoji: '🍝' },
        { italian: 'da asporto', english: 'takeaway', emoji: '📦' },
      ],
    },
  
    {
        slug: 'pasti',
        name: 'I Pasti',
        emoji: '🍽️',
        words: [
          { italian: 'la colazione', english: 'breakfast', emoji: '🌅' },
          { italian: 'il pranzo', english: 'lunch', emoji: '☀️' },
          { italian: 'la cena', english: 'dinner', emoji: '🌙' },
          { italian: "l'antipasto", english: 'appetizers', emoji: '🍢' },
          { italian: 'il primo', english: 'first course', emoji: '1️⃣' },
          { italian: 'il secondo', english: 'second course', emoji: '2️⃣' },
          { italian: 'il contorno', english: 'side dish', emoji: '🥗' },
          { italian: 'il dolce', english: 'dessert', emoji: '🍰' },
          { italian: 'la torta', english: 'cake', emoji: '🍰' },
          { italian: "una bottiglia di", english: "a bottle of", emoji: '🍾' },
          { italian: 'un bicchiere di', english: 'a glass of', emoji: '🥛' },
          { italian: 'la frutta', english: 'fruit', emoji: '🍎' },
          { italian: 'la verdura', english: 'vegetables', emoji: '🥦' },
          { italian: 'è delizioso', english: "it's delicious", emoji: '😋' },
          { italian: 'non mi piace', english: "I don't like it", emoji: '😕' },
          { italian: 'sono vegetariano/a', english: "I'm vegetarian", emoji: '🥗' },
          { italian: 'sono vegano/a', english: "I'm vegan", emoji: '🌱' },
          { italian: 'sono allergico/a a', english: "I'm allergic to", emoji: '⚠️' },
          { italian: 'sono intollerante al lattosio', english:"I'm lactose intolerant", emoji: '🥛' },
          { italian: 'senza glutine', english: 'gluten free', emoji: '🌾' },
          { italian: 'il vassoio', english: 'tray', emoji: '🍽️' },
          { italian: 'la ricetta', english: 'recipe', emoji: '📋' },
        ],
      },
      
      {
        slug: 'primi_piatti',
        name: 'Primi Piatti & Pasta',
        emoji: '🍝',
        words: [
          { italian: 'la pasta', english: 'pasta', emoji: '🍝' },
          { italian: 'gli spaghetti', english: 'spaghetti', emoji: '🍝' },
          { italian: 'gli gnocchi', english: 'gnocchi', emoji: '🍝' },
          { italian: 'la lasagna', english: 'lasagna', emoji: '🍝' },
          { italian: 'i rigatoni', english: 'rigatoni', emoji: '🍝' },
          { italian: 'le tagliatelle', english: 'tagliatelle', emoji: '🍝' },
          { italian: 'i tortellini', english: 'tortellini', emoji: '🍝' },
          { italian: 'la carbonara', english: 'carbonara', emoji: '🍝' },
          { italian: "l'amatriciana", english: 'amatriciana', emoji: '🍝' },
          { italian: 'la cacio e pepe', english: 'cacio e pepe', emoji: '🍝' },
          { italian: 'il risotto', english: 'risotto', emoji: '🍚' },
          { italian: 'il riso', english: 'rice', emoji: '🍚' },
          { italian: 'il ragù alla bolognese', english: 'bolognese sauce', emoji: '🍝' },
          { italian: 'il sugo al pomodoro', english: 'tomato sauce', emoji: '🍅' },
          { italian: 'il pesto', english: 'pesto', emoji: '🌿' },
          { italian: 'la minestra', english: 'soup', emoji: '🍲' },
          { italian: 'il minestrone', english: 'minestrone', emoji: '🍲' },
          { italian: 'la pizza', english: 'pizza', emoji: '🍕' },
          { italian: 'il purè', english: 'mashed potato', emoji: '🥔' }, 
          { italian: 'il brodo', english: 'broth', emoji: '🍲' },
        ],
      },
      
      {
        slug: 'secondi_contorni',
        name: 'Secondi & Condimenti',
        emoji: '🥩',
        words: [
          { italian: 'la carne', english: 'meat', emoji: '🥩' },
          { italian: 'la bistecca di manzo', english: 'beef steak', emoji: '🥩' },
          { italian: 'il pollo', english: 'chicken', emoji: '🍗' },
          { italian: 'le uova', english: 'eggs', emoji: '🥚' },
          { italian: 'il vitello', english: 'veal', emoji: '🥩' },
          { italian: 'il maiale', english: 'pork', emoji: '🐖' },
          { italian: 'il manzo', english: 'beef', emoji: '🥩' },
          { italian: 'la salsiccia', english: 'sausage', emoji: '🌭' },
          { italian: "l'hamburger", english: 'hamburger', emoji: '🍔' },
          { italian: 'il prosciutto', english: 'ham / prosciutto', emoji: '🥩' },
          { italian: 'gli affettati', english: 'cold cuts', emoji: '🥩' },
          { italian: 'il pesce', english: 'fish', emoji: '🐟' },
          { italian: 'il tonno', english: 'tuna', emoji: '🐟' },
          { italian: 'il salmone', english: 'salmon', emoji: '🐟' },
          { italian: 'le cozze', english: 'mussels', emoji: '🦪' },
          { italian: 'le vongole', english: 'clams', emoji: '🦪' },
          { italian: 'i gamberi', english: 'prawns', emoji: '🦐' },
          { italian: 'i gamberetti', english: 'shrimps', emoji: '🦐' },
          { italian: 'il tofu', english: 'tofu', emoji: '🌿' },
          { italian: "l'insalata", english: 'salad', emoji: '🥗' },
          { italian: 'le patatine fritte', english: 'French fries', emoji: '🍟' },
          { italian: 'le patate al forno', english: 'roasted potatoes', emoji: '🥔' },
          { italian: 'il formaggio', english: 'cheese', emoji: '🧀' },
          { italian: 'la mozzarella', english: 'mozzarella', emoji: '🧀' },
          { italian: 'il parmigiano', english: 'parmesan', emoji: '🧀' },
          { italian: 'la ricotta', english: 'ricotta', emoji: '🧀' },
          { italian: 'le olive', english: 'olives', emoji: '🫒' },
          { italian: 'i crostini', english: 'crostini', emoji: '🍞' },
          { italian: 'il sale', english: 'salt', emoji: '🧂' },
          { italian: 'il pepe', english: 'pepper', emoji: '🌶️' },
          { italian: "l'olio", english: 'oil', emoji: '🫙' },
          { italian: 'l\'aceto', english: 'vinegar', emoji: '🫙' },
          { italian: 'i ceci', english: 'chickpeas', emoji: '🫘' },
          { italian: 'i peperoni', english: 'peppers', emoji: '🌶️' },
          { italian: 'il sedano', english: 'celery', emoji: '🌿' },
          { italian: 'il ketchup', english: 'ketchup', emoji: '🍅' },
          { italian: 'la maionese', english: 'mayonnaise', emoji: '🫙' },
          { italian: 'la senape', english: 'mustard', emoji: '🫙' },
        ],
      },
  
    {
        slug: 'frutta',
        name: 'La Frutta',
        emoji: '🍎',
        words: [
          { italian: 'la banana', english: 'banana', emoji: '🍌' },
          { italian: "l'uva", english: 'grapes', emoji: '🍇' },
          { italian: 'la pera', english: 'pear', emoji: '🍐' },
          { italian: "l'arancia", english: 'orange', emoji: '🍊' },
          { italian: 'il pompelmo', english: 'grapefruit', emoji: '🍊' },
          { italian: 'il mandarino', english: 'mandarin', emoji: '🍊' },
          { italian: "l'albicocca", english: 'apricot', emoji: '🍑' },
          { italian: 'il melone', english: 'melon', emoji: '🍈' },
          { italian: 'la pesca', english: 'peach', emoji: '🍑' },
          { italian: 'il kiwi', english: 'kiwi', emoji: '🥝' },
          { italian: "l'anguria", english: 'watermelon', emoji: '🍉' },
          { italian: 'il cocco', english: 'coconut', emoji: '🥥' },
          { italian: 'la melagrana', english: 'pomegranate', emoji: '🍎' },
          { italian: 'la fragola', english: 'strawberry', emoji: '🍓' },
          { italian: 'la ciliegia', english: 'cherry', emoji: '🍒' },
          { italian: 'la susina', english: 'plum', emoji: '🍑' },
          { italian: "l'ananas", english: 'pineapple', emoji: '🍍' },
          { italian: 'il lampone', english: 'raspberry', emoji: '🍓' },
          { italian: 'il limone', english: 'lemon', emoji: '🍋' },
          { italian: 'la mela', english: 'apple', emoji: '🍎' },
          { italian: 'il fico', english: 'fig', emoji: '🫐' },
          { italian: 'i mirtilli', english: 'blueberries', emoji: '🫐' },
          { italian: 'la prugna', english: 'prune', emoji: '🟣' },
          { italian: 'la noce', english: 'walnut', emoji: '🌰' },
          { italian: 'la nocciola', english: 'hazelnut', emoji: '🌰' },
          { italian: 'la castagna', english: 'chestnut', emoji: '🌰' },
          { italian: 'le arachidi', english: 'peanuts', emoji: '🥜' },
          { italian: 'il dattero', english: 'date', emoji: '🌴' },
        ],
      },
      
      {
        slug: 'verdura',
        name: 'La Verdura',
        emoji: '🥦',
        words: [
          { italian: 'le patate', english: 'potatoes', emoji: '🥔' },
          { italian: 'gli spinaci', english: 'spinach', emoji: '🥬' },
          { italian: 'i fagiolini', english: 'green beans', emoji: '🫛' },
          { italian: 'i piselli', english: 'peas', emoji: '🫛' },
          { italian: 'i fagioli', english: 'beans', emoji: '🫘' },
          { italian: 'le lenticchie', english: 'lentils', emoji: '🫘' },
          { italian: 'la zucca', english: 'pumpkin', emoji: '🎃' },
          { italian: 'la carota', english: 'carrot', emoji: '🥕' },
          { italian: 'il cavolfiore', english: 'cauliflower', emoji: '🥦' },
          { italian: 'il fungo', english: 'mushroom', emoji: '🍄' },
          { italian: 'il porro', english: 'leek', emoji: '🌿' },
          { italian: 'il cetriolo', english: 'cucumber', emoji: '🥒' },
          { italian: 'il sedano', english: 'celery', emoji: '🌿' },
          { italian: 'la cipolla', english: 'onion', emoji: '🧅' },
          { italian: 'il cavolo', english: 'cabbage', emoji: '🥬' },
          { italian: 'la lattuga', english: 'lettuce', emoji: '🥬' },
          { italian: 'il pomodoro', english: 'tomato', emoji: '🍅' },
          { italian: 'il broccolo', english: 'broccoli', emoji: '🥦' },
          { italian: 'la melanzana', english: 'eggplant', emoji: '🍆' },
          { italian: 'gli asparagi', english: 'asparagus', emoji: '🌿' },
          { italian: 'il finocchio', english: 'fennel', emoji: '🌿' },
          { italian: 'il peperoncino', english: 'chili pepper', emoji: '🌶️' },
          { italian: "l'aglio", english: 'garlic', emoji: '🧄' },
          { italian: 'la zucchina', english: 'zucchini', emoji: '🥒' },
          { italian: 'il mais', english: 'corn', emoji: '🌽' },
          { italian: 'il radicchio', english: 'radicchio', emoji: '🥬' },
          { italian: 'il prezzemolo', english: 'parsley', emoji: '🌿' },
          { italian: 'il basilico', english: 'basil', emoji: '🌿' },
          { italian: 'il rosmarino', english: 'rosemary', emoji: '🌿' },
          { italian: 'la rucola', english: 'rocket / arugula', emoji: '🥬' },
        ],
      },
      
      {
        slug: 'supermercato',
        name: 'Al Supermercato',
        emoji: '🛒',
        words: [
          { italian: 'il carrello', english: 'shopping cart', emoji: '🛒' },
          { italian: 'il cestino', english: 'shopping basket', emoji: '🧺' },
          { italian: 'la cassa', english: 'checkout / cash register', emoji: '💰' },
          { italian: 'i soldi', english: 'money', emoji: '💰' },
          { italian: 'la borsa', english: 'bag / handbag', emoji: '👜' },
          { italian: 'il borsellino', english: 'purse / wallet', emoji: '👛' },
          { italian: 'le bottiglie', english: 'bottles', emoji: '🍶' },
          { italian: 'i barattoli', english: 'tins / jars', emoji: '🫙' },
          { italian: 'il cibo in scatola', english: 'tinned / canned food', emoji: '🥫' },
          { italian: 'la farina', english: 'flour', emoji: '🌾' },
          { italian: 'la bilancia', english: 'scales', emoji: '⚖️' },
          { italian: 'la carne', english: 'meat', emoji: '🥩' },
          { italian: 'lo yogurt', english: 'yoghurt', emoji: '🥛' },
          { italian: 'la carne macinata', english: 'ground meat', emoji: '🥩' },
          { italian: 'il pane', english: 'bread', emoji: '🍞' },
          { italian: 'il burro', english: 'butter', emoji: '🧈' },
          { italian: 'il latte', english: 'milk', emoji: '🥛' },
          { italian: 'le uova', english: 'eggs', emoji: '🥚' },
          { italian: 'il succo di frutta', english: 'fruit juice', emoji: '🧃' },
          { italian: 'la pasta secca', english: 'dried pasta', emoji: '🍝' },
          { italian: 'il tonno in scatola', english: 'canned tuna', emoji: '🐟' },
          { italian: 'il detersivo', english: 'detergent', emoji: '🧴' },
          { italian: 'la carta igienica', english: 'toilet paper', emoji: '🧻' },
          { italian: 'lo scontrino', english: 'receipt', emoji: '🧾' },
          { italian: 'la tessera fedeltà', english: 'loyalty card', emoji: '💳' },
        ],
      },
  
    // ══════════════════════════════════════════════════════════════════════
    // A2 LIVELLO 7: LA MIA ROUTINE
    // ══════════════════════════════════════════════════════════════════════
  
    {
        slug: 'vestiti',
        name: 'I Vestiti',
        emoji: '👗',
        words: [
          { italian: 'i calzini', english: 'socks', emoji: '🧦' },
          { italian: 'le mutande', english: 'underpants', emoji: '🩲' },
          { italian: 'la canottiera', english: 'vest / tank top', emoji: '👕' },
          { italian: 'i pantaloni', english: 'trousers', emoji: '👖' },
          { italian: 'i jeans', english: 'jeans', emoji: '👖' },
          { italian: 'la maglietta', english: 'T-shirt', emoji: '👕' },
          { italian: 'la gonna', english: 'skirt', emoji: '👗' },
          { italian: 'la camicia', english: 'shirt', emoji: '👔' },
          { italian: 'la camicetta', english: 'blouse', emoji: '👚' },
          { italian: 'la cravatta', english: 'tie', emoji: '👔' },
          { italian: 'i pantaloncini', english: 'shorts', emoji: '🩳' },
          { italian: 'la calzamaglia', english: 'tights', emoji: '🧦' },
          { italian: 'il vestito', english: 'dress / suit', emoji: '👗' },
          { italian: 'il maglione', english: 'jumper / sweater', emoji: '🧥' },
          { italian: 'la felpa', english: 'sweatshirt / hoodie', emoji: '👕' },
          { italian: 'il cardigan', english: 'cardigan', emoji: '🧥' },
          { italian: 'il cappotto', english: 'coat', emoji: '🧥' },
          { italian: 'il giubbotto', english: 'jacket', emoji: '🧥' },
          { italian: 'il pigiama', english: 'pajama', emoji: '🛌' },
          { italian: 'il costume da bagno', english: 'swimsuit', emoji: '🩱' },
          { italian: "l'impermeabile", english: 'raincoat', emoji: '🧥' },
          { italian: 'le pantofole', english: 'slippers', emoji: '🥿' },
          { italian: 'le scarpe da ginnastica', english: 'trainers / sneakers', emoji: '👟' },
          { italian: 'le scarpe', english: 'shoes', emoji: '👞' },
          { italian: 'i sandali', english: 'sandals', emoji: '👡' },
          { italian: 'le ciabatte', english: 'flipflops', emoji: '🩴' },
          { italian: 'gli stivali di gomma', english: 'wellington boots', emoji: '🥾' },
          { italian: 'le scarpe col tacco', english: 'high heeled shoes', emoji: '👠' },
          { italian: 'la sciarpa', english: 'scarf', emoji: '🧣' },
          { italian: 'i guanti', english: 'gloves', emoji: '🧤' },
          { italian: 'il cappello', english: 'hat', emoji: '🎩' },
          { italian: 'la cuffia', english: 'winter hat', emoji: '🧢' },
          { italian: 'il reggiseno', english: 'bra', emoji: '🩱' },
          { italian: 'il completo', english: 'suit (matching set)', emoji: '👔' },
          { italian: 'il tailleur', english: 'women\'s suit', emoji: '👗' },
          { italian: 'la tuta', english: 'tracksuit / overalls', emoji: '🏃' },
          { italian: 'il grembiule', english: 'apron', emoji: '👨‍🍳' },
          { italian: 'i collant', english: 'stockings', emoji: '🧦' },
        ],
      },
      
      {
        slug: 'accessori',
        name: 'Gli Accessori',
        emoji: '💍',
        words: [
          { italian: "l'anello", english: 'ring', emoji: '💍' },
          { italian: "l'orologio", english: 'watch', emoji: '⌚' },
          { italian: 'il bracciale', english: 'bracelet', emoji: '📿' },
          { italian: 'gli orecchini', english: 'earrings', emoji: '💎' },
          { italian: 'gli occhiali', english: 'glasses', emoji: '👓' },
          { italian: 'la borsa', english: 'bag', emoji: '👜' },
          { italian: 'la cintura', english: 'belt', emoji: '🪢' },
          { italian: 'la fibbia', english: 'buckle' },
          { italian: 'la cerniera lampo', english: 'zip' },
          { italian: 'i bottoni', english: 'buttons' },
          { italian: 'le tasche', english: 'pockets' },
          { italian: 'il fazzoletto', english: 'handkerchief' },
          { italian: 'la collana', english: 'necklace', emoji: '📿' },
          { italian: 'la spilla', english: 'brooch / pin', emoji: '📌' },
          { italian: 'il portafoglio', english: 'wallet', emoji: '👛' },
          { italian: 'lo zaino', english: 'backpack', emoji: '🎒' },
          { italian: 'la valigia', english: 'suitcase', emoji: '🧳' },
          { italian: 'l\'ombrello', english: 'umbrella', emoji: '☂️' },
          { italian: 'gli occhiali da sole', english: 'sunglasses', emoji: '🕶️' },
          { italian: 'gli occhiali da vista', english: 'eyeglasses', emoji: '🕶️' },
          { italian: 'il cappellino', english: 'baseball cap', emoji: '🧢' },
        ],
      },
  
    // ══════════════════════════════════════════════════════════════════════
    // A2 LIVELLO 8: LA MIA SALUTE
    // ══════════════════════════════════════════════════════════════════════
  
    {
      slug: 'corpo',
      name: 'Le Parti del Corpo',
      emoji: '🫀',
      words: [
        { italian: 'la testa', english: 'head', emoji: '🗣️' },
        { italian: 'i capelli', english: 'hair', emoji: '💇' },
        { italian: 'il viso', english: 'face', emoji: '😊' },
        { italian: 'la guancia', english: 'cheek' },
        { italian: 'il labbro / le labbra', english: 'lips', emoji: '💋' },
        { italian: 'la lingua', english: 'tongue', emoji: '👅' },
        { italian: 'il mento', english: 'chin' },
        { italian: 'il collo', english: 'neck' },
        { italian: 'il torace', english: 'torso' },
        { italian: 'il sedere', english: 'butt' },
        { italian: 'il pollice', english: 'thumb', emoji: '👍' },
        { italian: 'le dita della mano', english: 'fingers', emoji: '🖐️' },
        { italian: 'le dita del piede', english: 'toes', emoji: '🦶' },
        { italian: 'le sopracciglia', english: 'eyebrows' },
        { italian: 'le ciglia', english: 'eyelashes' },
        { italian: 'il naso', english: 'nose', emoji: '👃' },
        { italian: 'la bocca', english: 'mouth', emoji: '👄' },
        { italian: "l'occhio", english: 'eye', emoji: '👁️' },
        { italian: "l'orecchio / le orecchie", english: 'ear', emoji: '👂' },
        { italian: 'i denti', english: 'teeth', emoji: '🦷' },
        { italian: 'la gola', english: 'throat' },
        { italian: 'la pancia', english: 'belly', emoji: '🫃' },
        { italian: 'lo stomaco', english: 'stomach' },
        { italian: 'il braccio', english: 'arm', emoji: '💪' },
        { italian: 'la mano', english: 'hand', emoji: '✋' },
        { italian: 'il ginocchio', english: 'knee' },
        { italian: 'il piede', english: 'foot', emoji: '🦶' },
        { italian: 'la schiena', english: 'back' },
        { italian: 'la fronte', english: 'forehead', emoji: '😊' },
        { italian: 'le spalle', english: 'shoulders', emoji: '💪' },
        { italian: 'il petto', english: 'chest', emoji: '💪' },
        { italian: 'il polso', english: 'wrist', emoji: '⌚' },
        { italian: 'il gomito', english: 'elbow' },
        { italian: 'la caviglia', english: 'ankle' },
        { italian: 'il tallone', english: 'heel' },
        { italian: 'il polpaccio', english: 'calf (leg)' },
        { italian: 'la coscia', english: 'thigh' },
        { italian: 'il sopracciglio', english: 'eyebrow' },
        { italian: 'le unghie', english: 'nails', emoji: '💅' },
        { italian: 'la pelle', english: 'skin', emoji: '🫶' },
        { italian: 'il sangue', english: 'blood', emoji: '🩸' },
        { italian: 'il cuore', english: 'heart', emoji: '❤️' },
        { italian: 'il polmone', english: 'lung', emoji: '🫁' },
        { italian: 'il fegato', english: 'liver' },
        { italian: 'il rene', english: 'kidney' },
      ],
    },
  
    {
      slug: 'dottore',
      name: 'Dal Dottore & In Ospedale',
      emoji: '🏥',
      words: [
        { italian: 'il mal di testa', english: 'headache', emoji: '🤕' },
        { italian: 'il mal di denti', english: 'toothache', emoji: '🦷' },
        { italian: 'il mal di schiena', english: 'backache', emoji: '😣' },
        { italian: 'ho mal di stomaco', english: 'I have a stomach ache', emoji: '🤢' },
        { italian: 'mi sono fatto/a male', english: 'I hurt myself', emoji: '🤕' },
        { italian: 'sono stanco/a', english: "I'm tired", emoji: '😴' },
        { italian: 'mi sento male', english: "I don't feel well", emoji: '🤒' },
        { italian: 'ho la nausea', english: "I feel nauseous", emoji: '🤢' },
        { italian: 'ho le vertigini', english: "I feel dizzy", emoji: '😵' },
        { italian: 'la ricetta medica', english: 'prescription', emoji: '📋' },
        { italian: 'la visita medica', english: 'medical appointment', emoji: '🏥' },
        { italian: 'il pronto soccorso', english: 'emergency room', emoji: '🚨' },
        { italian: 'l\'ambulanza', english: 'ambulance', emoji: '🚑' },
        { italian: 'l\'allergia', english: 'allergy', emoji: '⚠️' },
        { italian: 'il dolore', english: 'pain', emoji: '😣' },
        { italian: 'la ferita', english: 'wound', emoji: '🩹' },
        { italian: 'l\'operazione', english: 'surgery / operation', emoji: '🔪' },
        { italian: 'il ricovero', english: 'hospitalisation', emoji: '🏥' },
        { italian: 'la tosse', english: 'cough', emoji: '🤧' },
        { italian: 'il raffreddore', english: 'cold', emoji: '🤧' },
        { italian: 'la febbre', english: 'fever', emoji: '🤒' },
        { italian: 'il cerotto', english: 'plaster / band-aid', emoji: '🩹' },
        { italian: 'la pastiglia', english: 'tablet', emoji: '💊' },
        { italian: 'le pillole', english: 'pills', emoji: '💊' },
        { italian: 'il termometro', english: 'thermometer', emoji: '🌡️' },
        { italian: 'il gesso', english: 'cast', emoji: '🦴' },
        { italian: 'la sedia a rotelle', english: 'wheel chair', emoji: '♿' },
        { italian: 'la siringa', english: 'syringe', emoji: '💉' },
        { italian: 'il pannolino', english: 'diaper', emoji: '👶' },
        { italian: 'la camicia da notte', english: 'nightgown', emoji: '🛌' },
        { italian: "la sala d'aspetto", english: 'waiting room', emoji: '🪑' },
        { italian: 'lo sciroppo', english: 'syrup', emoji: '🍶' },
        { italian: 'la benda', english: 'bandage', emoji: '🩹' },
        { italian: 'le analisi del sangue', english: 'blood tests', emoji: '🩸' },
        { italian: 'la dottoressa / il dottore', english: 'doctor', emoji: '👨‍⚕️' },
        { italian: "l'infermiera / l'infermiere", english: 'nurse', emoji: '👩‍⚕️' },
        { italian: "l'ascensore", english: 'elevator', emoji: '🛗' },
        { italian: 'le stampelle', english: 'crutches', emoji: '🩼' },
      ],
    },
  
    // ══════════════════════════════════════════════════════════════════════
    // A2 CASA E VACANZE
    // ══════════════════════════════════════════════════════════════════════
  
    {
      slug: 'casa_generale',
      name: 'A Casa',
      emoji: '🏠',
      words: [
        { italian: 'i mattoni', english: 'bricks', emoji: '🧱' },
        { italian: 'la chiave', english: 'key', emoji: '🔑' },
        { italian: "l'interruttore", english: 'light switch', emoji: '💡' },
        { italian: 'la finestra', english: 'window', emoji: '🪟' },
        { italian: 'la porta', english: 'door', emoji: '🚪' },
        { italian: 'le scale', english: 'stairs', emoji: '🪜' },
        { italian: 'il quadro', english: 'picture / painting', emoji: '🖼️' },
        { italian: 'il telefono', english: 'telephone', emoji: '📞' },
        { italian: 'il radiatore', english: 'radiator', emoji: '🌡️' },
        { italian: 'le lettere', english: 'letters / post', emoji: '📬' },
        { italian: 'il giornale', english: 'newspaper', emoji: '📰' },
        { italian: 'la moquette', english: 'carpet (fitted)', emoji: '🏠' },
        { italian: 'la lampadina', english: 'light bulb', emoji: '💡' },
        { italian: 'la parete', english: 'wall' },
        { italian: 'il pavimento', english: 'floor' },
        { italian: 'il soffitto', english: 'ceiling' },
        { italian: "l'avvolgibile", english: 'blind / roller blind' },
        { italian: "l'attaccapanni", english: 'coat rack', emoji: '🧥' },
        { italian: 'la cantina', english: 'cellar' },
        { italian: "l'attico", english: 'attic' },
        { italian: 'le mattonelle', english: 'tiles' },
      ],
    },
  
    {
      slug: 'bagno',
      name: 'Il Bagno',
      emoji: '🚿',
      words: [
        { italian: 'la vasca', english: 'bath tub', emoji: '🛁' },
        { italian: 'la doccia', english: 'shower', emoji: '🚿' },
        { italian: 'il lavandino', english: 'sink', emoji: '🪣' },
        { italian: 'il water / il gabinetto', english: 'toilet', emoji: '🚽' },
        { italian: 'il rubinetto', english: 'tap / faucet', emoji: '🚰' },
        { italian: 'il sapone / la saponetta', english: 'soap', emoji: '🧼' },
        { italian: 'la carta igienica', english: 'toilet paper', emoji: '🧻' },
        { italian: "l'asciugamano", english: 'towel', emoji: '🏊' },
        { italian: 'lo spazzolino', english: 'toothbrush', emoji: '🪥' },
        { italian: 'il dentifricio', english: 'toothpaste', emoji: '🦷' },
        { italian: 'la spugna', english: 'sponge', emoji: '🧽' },
        { italian: "l'acqua", english: 'water', emoji: '💧' },
        { italian: 'il pettine', english: 'comb', emoji: '💇' },
        { italian: 'la spazzola', english: 'hairbrush', emoji: '💇' },
        { italian: 'la lavatrice', english: 'washing machine', emoji: '🫧' },
        { italian: 'la radio', english: 'radio', emoji: '📻' },
      ],
    },
  
    {
      slug: 'camera_da_letto',
      name: 'La Camera da Letto',
      emoji: '🛏️',
      words: [
        { italian: 'il letto matrimoniale', english: 'double bed', emoji: '🛏️' },
        { italian: 'il letto a castello', english: 'bunk bed', emoji: '🛏️' },
        { italian: 'il comodino', english: 'bedside table', emoji: '🪵' },
        { italian: 'il cassettone', english: 'chest of drawers', emoji: '🗄️' },
        { italian: "l'armadio", english: 'wardrobe', emoji: '🚪' },
        { italian: 'lo specchio', english: 'mirror', emoji: '🪞' },
        { italian: 'il cuscino', english: 'pillow', emoji: '🛌' },
        { italian: 'il piumone', english: 'duvet', emoji: '🛌' },
        { italian: 'il lenzuolo', english: 'bed sheet', emoji: '🛌' },
        { italian: 'la coperta', english: 'blanket', emoji: '🛌' },
        { italian: 'il materasso', english: 'mattress', emoji: '🛏️' },
        { italian: 'la scrivania', english: 'desk', emoji: '🖥️' },
        { italian: 'la lampada', english: 'lamp', emoji: '🪔' },
        { italian: 'i poster', english: 'posters', emoji: '🖼️' },
        { italian: 'il tappeto', english: 'rug', emoji: '🏠' },
        { italian: 'la carrozzina', english: 'baby carriage', emoji: '🍼' },
        { italian: 'le mensole', english: 'shelves', emoji: '📚' },
      ],
    },
  
    {
      slug: 'cucina_stanza',
      name: 'La Cucina',
      emoji: '🍳',
      words: [
        { italian: 'il frigorifero', english: 'fridge', emoji: '🧊' },
        { italian: 'i bicchieri', english: 'glasses', emoji: '🥛' },
        { italian: 'le tende', english: 'curtains', emoji: '🪟' },
        { italian: 'il forno', english: 'oven', emoji: '🍳' },
        { italian: "l'orologio", english: 'clock', emoji: '🕐' },
        { italian: 'il fornello / i fornelli', english: 'hob / stove', emoji: '🔥' },
        { italian: 'il forno a microonde', english: 'microwave', emoji: '📦' },
        { italian: 'la lavastoviglie', english: 'dishwasher', emoji: '🫧' },
        { italian: 'il lavello', english: 'kitchen sink', emoji: '🚰' },
        { italian: 'la macchina del caffè', english: 'coffee machine', emoji: '☕' },
        { italian: 'il tostapane', english: 'toaster', emoji: '🍞' },
        { italian: 'il bollitore', english: 'kettle', emoji: '🫖' },
        { italian: 'le pentole', english: 'pots', emoji: '🫕' },
        { italian: 'il tagliere', english: 'cutting board', emoji: '🪵' },
        { italian: 'le forchette', english: 'forks', emoji: '🍴' },
        { italian: 'lo sgabello', english: 'stool', emoji: '🪑' },
        { italian: 'la padella', english: 'frying pan', emoji: '🍳' },
        { italian: 'i piatti', english: 'plates', emoji: '🍽️' },
        { italian: 'i piattini', english: 'saucers', emoji: '🫖' },
        { italian: 'le tazze', english: 'cups', emoji: '☕' },
        { italian: 'la grattugia', english: 'grater', emoji: '🧀' },
        { italian: 'il frullatore', english: 'blender', emoji: '🥤' },
        { italian: 'i cucchiai', english: 'spoons', emoji: '🥄' },
        { italian: 'i cucchiaini', english: 'teaspoons', emoji: '🥄' },
        { italian: 'i mestoli', english: 'wooden spoons / ladles', emoji: '🥄' },
        { italian: 'i coltelli', english: 'knives', emoji: '🔪' },
        { italian: 'i fiammiferi', english: 'matches', emoji: '🔥' },
        { italian: 'lo strofinaccio', english: 'tea towel', emoji: '🧻' },
        { italian: "l'armadietto", english: 'kitchen cupboard', emoji: '🚪' },
        { italian: 'il cassetto', english: 'drawer' },
        { italian: 'le scodelle', english: 'bowls', emoji: '🍜' },
        { italian: 'il detersivo per piatti', english: 'dish soap', emoji: '🧴' },
        { italian: 'il grembiule', english: 'apron', emoji: '👨‍🍳' },
        { italian: 'la spazzatura', english: 'trash', emoji: '🗑️' },
      ],
    },
  
    {
      slug: 'ripostiglio',
      name: 'Il Ripostiglio',
      emoji: '🧹',
      words: [
        { italian: 'il ferro da stiro', english: 'iron', emoji: '👔' },
        { italian: 'lo spazzolone', english: 'mop', emoji: '🧹' },
        { italian: 'la scopa', english: 'broom', emoji: '🧹' },
        { italian: 'lo straccio', english: 'cleaning cloth / mop', emoji: '🧽' },
        { italian: 'la paletta', english: 'dustpan', emoji: '🧹' },
        { italian: 'la lavatrice', english: 'washing machine', emoji: '🫧' },
        { italian: "l'asciugatrice", english: 'dryer', emoji: '🌀' },
        { italian: "l'asse da stiro", english: 'ironing board', emoji: '👔' },
        { italian: 'le mattonelle', english: 'tiles' },
        { italian: 'il secchio', english: 'bucket', emoji: '🪣' },
        { italian: 'la spazzola per pavimenti', english: 'floor brush', emoji: '🧹' },
        { italian: 'il detersivo', english: 'detergent', emoji: '🧴' },
        { italian: 'il detersivo per bucato', english: 'laundry detergent', emoji: '🧴' },
        { italian: 'l\'ammorbidente', english: 'fabric softener', emoji: '🧴' },
        { italian: 'la candeggina', english: 'bleach', emoji: '🧴' },
        { italian: 'i guanti di gomma', english: 'rubber gloves', emoji: '🧤' },
        { italian: 'la spugna', english: 'sponge', emoji: '🧽' },
        { italian: 'la scopa elettrica', english: 'vacuum cleaner', emoji: '🧹' },
        { italian: 'il mocio', english: 'mop with a head', emoji: '🧹' },
        { italian: 'la carta assorbente', english: 'paper towels', emoji: '🧻' },
        { italian: 'il sacchetto della spazzatura', english: 'bin bag', emoji: '🗑️' },
        { italian: 'lo spray per pulire', english: 'cleaning spray', emoji: '💦' },
        { italian: 'la corda per stendere', english: 'washing line', emoji: '👕' },
        { italian: 'le mollette', english: 'clothes pegs', emoji: '🪢' },
      ],
    },
  
    {
      slug: 'soggiorno',
      name: 'Il Soggiorno',
      emoji: '🛋️',
      words: [
        { italian: 'il televisore', english: 'television', emoji: '📺' },
        { italian: 'il telecomando', english: 'remote control', emoji: '📺' },
        { italian: 'la radio', english: 'radio', emoji: '📻' },
        { italian: 'lo stereo', english: 'stereo', emoji: '🎵' },
        { italian: 'la libreria', english: 'bookcase', emoji: '📚' },
        { italian: 'gli scaffali / le mensole', english: 'shelves', emoji: '📚' },
        { italian: 'la pianta', english: 'plant', emoji: '🪴' },
        { italian: 'il vaso di fiori', english: 'flower vase', emoji: '💐' },
        { italian: 'il camino', english: 'fireplace', emoji: '🔥' },
        { italian: "l'acquario", english: 'fish tank', emoji: '🐠' },
        { italian: 'la moquette', english: 'carpet', emoji: '🏠' },
        { italian: 'il divano', english: 'sofa', emoji: '🛋️' },
        { italian: 'le tende', english: 'curtains', emoji: '🪟' },
        { italian: 'il vaso', english: 'vase', emoji: '🏺' },
        { italian: "l'attaccapanni", english: 'coat hanger', emoji: '🧥' },
      ],
    },
  
    {
      slug: 'giardino',
      name: 'Il Giardino',
      emoji: '🌿',
      words: [
        { italian: "l'ape", english: 'bee', emoji: '🐝' },
        { italian: "l'erba", english: 'grass', emoji: '🌿' },
        { italian: "l'albero", english: 'tree', emoji: '🌳' },
        { italian: 'la siepe', english: 'hedge', emoji: '🌿' },
        { italian: 'il fiore', english: 'flower', emoji: '🌸' },
        { italian: "l'aiuola", english: 'flower bed', emoji: '🌺' },
        { italian: 'le foglie', english: 'leaves', emoji: '🍃' },
        { italian: 'il tosaerba', english: 'lawnmower', emoji: '🌿' },
        { italian: 'il rastrello', english: 'rake', emoji: '🍂' },
        { italian: 'il forcone', english: 'pitchfork' },
        { italian: 'la paletta', english: 'trowel', emoji: '🌱' },
        { italian: 'il tubo di gomma', english: 'garden hose', emoji: '💧' },
        { italian: 'il falò', english: 'bonfire', emoji: '🔥' },
        { italian: 'il fumo', english: 'smoke', emoji: '💨' },
        { italian: 'il nido', english: 'nest', emoji: '🪺' },
        { italian: 'il bruco', english: 'caterpillar', emoji: '🐛' },
        { italian: "l'osso", english: 'bone', emoji: '🦴' },
        { italian: 'la scala', english: 'ladder', emoji: '🪜' },
        { italian: 'la serra', english: 'greenhouse', emoji: '🌱' },
        { italian: 'il sentiero', english: 'path', emoji: '🛤️' },
        { italian: 'i ramoscelli', english: 'twigs', emoji: '🌿' },
        { italian: 'la carriola', english: 'wheelbarrow', emoji: '🛒' },
        { italian: "l'alveare", english: 'hive', emoji: '🍯' },
        { italian: 'la vanga', english: 'spade', emoji: '⛏️' },
        { italian: 'la coccinella', english: 'ladybug', emoji: '🐞' },
        { italian: 'la pattumiera', english: 'garbage bin', emoji: '🗑️' },
        { italian: 'i semi', english: 'seeds', emoji: '🌱' },
        { italian: 'il casotto', english: 'shed' },
        { italian: 'il verme', english: 'worm', emoji: '🪱' },
        { italian: 'i fiori', english: 'flowers', emoji: '🌸' },
        { italian: "l'annaffiatore", english: 'sprinkler', emoji: '💧' },
        { italian: 'la zappa', english: 'hoe' },
        { italian: 'la vespa', english: 'wasp', emoji: '🐝' },
      ],
    },
  
    {
      slug: 'vacanze',
      name: 'Le Vacanze',
      emoji: '✈️',
      words: [
        { italian: "l'albergo", english: 'hotel', emoji: '🏨' },
        { italian: "l'albergo economico", english: 'affordable hotel', emoji: '🏩' },
        { italian: "l'albergo di lusso", english: 'luxury hotel', emoji: '🏰' },
        { italian: "l'ostello", english: 'hostel', emoji: '🏠' },
        { italian: 'il campeggio', english: 'camping / campsite', emoji: '⛺' },
        { italian: 'la camera singola', english: 'single room', emoji: '🛏️' },
        { italian: 'la camera doppia', english: 'double room', emoji: '🛏️' },
        { italian: 'al mare', english: 'at the seaside', emoji: '🏖️' },
        { italian: 'in montagna', english: 'in the mountains', emoji: '🏔️' },
        { italian: 'al lago', english: 'at the lake', emoji: '🏞️' },
        { italian: 'la crociera', english: 'cruise', emoji: '🚢' },
        { italian: "l'aereo", english: 'plane', emoji: '✈️' },
        { italian: 'il treno', english: 'train', emoji: '🚂' },
        { italian: "l'agriturismo", english: 'farm holiday', emoji: '🏡' },
        { italian: 'la valigia', english: 'suitcase', emoji: '🧳' },
        { italian: 'il passaporto', english: 'passport', emoji: '📘' },
        { italian: 'la macchina fotografica', english: 'camera', emoji: '📷' },
        { italian: "l'assicurazione sanitaria", english: 'health insurance', emoji: '🏥' },
        { italian: 'il visto', english: 'visa', emoji: '📋' },
        { italian: 'la cartina', english: 'map', emoji: '🗺️' },
        { italian: 'il check-in', english: 'check-in', emoji: '✅' },
        { italian: 'il check-out', english: 'check-out', emoji: '🚪' },
        { italian: 'la colazione inclusa', english: 'breakfast included', emoji: '🍳' },
        { italian: 'la mezza pensione', english: 'half board', emoji: '🍽️' },
        { italian: 'la pensione completa', english: 'full board', emoji: '🍽️' },
        { italian: 'il bagaglio a mano', english: 'hand luggage', emoji: '🎒' },
        { italian: 'il bagaglio in stiva', english: 'checked luggage', emoji: '🧳' },
        { italian: 'il decollo', english: 'take-off', emoji: '✈️' },
        { italian: 'l\'atterraggio', english: 'landing', emoji: '🛬' },
        { italian: 'il gate', english: 'gate', emoji: '🚪' },
        { italian: 'il controllo passaporti', english: 'passport control', emoji: '📘' },
        { italian: 'la dogana', english: 'customs', emoji: '🏛️' },
        { italian: 'il cambio valuta', english: 'currency exchange', emoji: '💱' },
        { italian: 'la guida turistica', english: 'tour guide', emoji: '🗺️' },
        { italian: 'il souvenir', english: 'souvenir', emoji: '🎁' },
        { italian: 'il tour', english: 'tour', emoji: '🚌' },
        { italian: 'la gita', english: 'day trip', emoji: '🚌' },
        { italian: 'la prenotazione online', english: 'online booking', emoji: '💻' },
        { italian: 'l\'assicurazione di viaggio', english: 'travel insurance', emoji: '🛡️' },
        { italian: 'il fuso orario', english: 'time zone', emoji: '🕐' },
        { italian: 'il jet lag', english: 'jet lag', emoji: '😴' },
      ],
    },
  
    // ══════════════════════════════════════════════════════════════════════
    // B1 LIVELLO 10: IL FUTURO
    // ══════════════════════════════════════════════════════════════════════
  
    {
      slug: 'mercato',
      name: 'Al Mercato',
      emoji: '🧺',
      words: [
        { italian: "l'affare", english: 'bargain', emoji: '💰' },
        { italian: 'il venditore / la venditrice', english: 'salesperson', emoji: '🧑‍💼' },
        { italian: 'fuori moda', english: 'out of style', emoji: '❌' },
        { italian: "all'ultima moda", english: 'in the latest style', emoji: '✨' },
        { italian: 'di moda', english: 'stylish', emoji: '👗' },
        { italian: 'in saldo', english: 'on sale', emoji: '🏷️' },
        { italian: 'il gelataio / la gelataia', english: 'ice cream vendor', emoji: '🍦' },
        { italian: 'il pasticcere / la pasticcera', english: 'pastry chef', emoji: '🍰' },
        { italian: 'fare la spesa', english: 'to go grocery shopping', emoji: '🛒' },
        { italian: 'fare le compere', english: 'to go shopping', emoji: '🛍️' },
        { italian: 'lo sconto', english: 'discount', emoji: '🏷️' },
        { italian: 'la vetrina', english: 'shop window', emoji: '🪟' },
        { italian: 'il commesso / la commessa', english: 'salesperson', emoji: '🧑‍💼' },
        { italian: 'il macellaio', english: 'butcher', emoji: '🥩' },
        { italian: 'il panettiere', english: 'baker', emoji: '🥖' },
        { italian: 'il pescivendolo / la pescivendola', english: 'fishmonger', emoji: '🐟' },
        { italian: 'il salumiere / la salumiera', english: 'deli owner', emoji: '🥩' },
        { italian: 'il negozio di alimentari', english: 'grocery store', emoji: '🏪' },
        { italian: 'la bancarella', english: 'stand', emoji: '⛺' },
        { italian: 'il mercato', english: 'market', emoji: '🏪' },
        { italian: 'il grande magazzino', english: 'department store', emoji: '🏬' },
        { italian: 'il negozio di abbigliamento', english: 'clothing store', emoji: '👗' },
      ],
    },
  
    {
      slug: 'aeroporto',
      name: "L'Aeroporto",
      emoji: '✈️',
      words: [
        { italian: "l'aereo", english: 'plane', emoji: '✈️' },
        { italian: "l'hostess", english: 'flight attendant (female)', emoji: '👩' },
        { italian: 'lo steward', english: 'flight attendant (male)', emoji: '👨' },
        { italian: 'il pilota', english: 'pilot', emoji: '👨‍✈️' },
        { italian: 'la pista di atterraggio', english: 'runway', emoji: '🛬' },
        { italian: 'la torre di controllo', english: 'control tower', emoji: '🗼' },
        { italian: 'il portabagagli', english: 'luggage trolley', emoji: '🧳' },
        { italian: 'il check-in', english: 'check-in', emoji: '✅' },
        { italian: 'il bagaglio', english: 'luggage', emoji: '🧳' },
        { italian: 'il bagaglio a mano', english: 'hand luggage', emoji: '🎒' },
        { italian: 'il bagaglio in stiva', english: 'checked luggage', emoji: '🧳' },
        { italian: 'il gate', english: 'gate', emoji: '🚪' },
        { italian: "l'imbarco", english: 'boarding', emoji: '✈️' },
        { italian: "la carta d'imbarco", english: 'boarding pass', emoji: '🎫' },
        { italian: 'il volo', english: 'flight', emoji: '✈️' },
        { italian: 'la partenza', english: 'departure', emoji: '🛫' },
        { italian: "l'arrivo", english: 'arrival', emoji: '🛬' },
        { italian: 'il ritardo', english: 'delay', emoji: '⏰' },
        { italian: 'la dogana', english: 'customs', emoji: '🏛️' },
        { italian: 'il controllo passaporti', english: 'passport control', emoji: '📘' },
        { italian: 'il nastro bagagli', english: 'baggage carousel', emoji: '🔄' },
        { italian: 'il terminal', english: 'terminal', emoji: '🏢' },
        { italian: "la sala d'attesa", english: 'waiting area', emoji: '🪑' },
        { italian: 'decollare', english: 'to take off', emoji: '🛫' },
        { italian: 'atterrare', english: 'to land', emoji: '🛬' },
      ],
    },
  
    // ══════════════════════════════════════════════════════════════════════
    // B1 LIVELLO 11: CONSIGLI E VIAGGI / L'AMBIENTE
    // ══════════════════════════════════════════════════════════════════════
  
    {
      slug: 'animali_selvatici',
      name: 'Gli Animali Selvatici',
      emoji: '🦁',
      words: [
        { italian: "l'elefante", english: 'elephant', emoji: '🐘' },
        { italian: 'la zebra', english: 'zebra', emoji: '🦓' },
        { italian: 'la tigre', english: 'tiger', emoji: '🐯' },
        { italian: 'il leopardo', english: 'leopard', emoji: '🐆' },
        { italian: 'il leone', english: 'lion', emoji: '🦁' },
        { italian: 'il rinoceronte', english: 'rhinoceros', emoji: '🦏' },
        { italian: 'il dromedario', english: 'camel / dromedary', emoji: '🐪' },
        { italian: 'la giraffa', english: 'giraffe', emoji: '🦒' },
        { italian: 'la scimmia', english: 'monkey', emoji: '🐒' },
        { italian: 'il cervo', english: 'deer', emoji: '🦌' },
        { italian: 'la tartaruga', english: 'tortoise / turtle', emoji: '🐢' },
        { italian: 'il bisonte', english: 'bison', emoji: '🦬' },
        { italian: 'la capra', english: 'goat', emoji: '🐐' },
        { italian: 'la foca', english: 'seal', emoji: '🦭' },
        { italian: "l'orso polare", english: 'polar bear', emoji: '🐻‍❄️' },
        { italian: 'lo squalo', english: 'shark', emoji: '🦈' },
        { italian: 'il serpente', english: 'snake', emoji: '🐍' },
        { italian: 'il castoro', english: 'beaver', emoji: '🦫' },
        { italian: 'la balena', english: 'whale', emoji: '🐋' },
        { italian: 'la proboscide', english: 'trunk (elephant)', emoji: '🐘' },
        { italian: 'le corna', english: 'antlers / horns', emoji: '🦌' },
        { italian: 'il panda', english: 'panda', emoji: '🐼' },
        { italian: "l'aquila", english: 'eagle', emoji: '🦅' },
        { italian: "l'ippopotamo", english: 'hippopotamus', emoji: '🦛' },
        { italian: 'il canguro', english: 'kangaroo', emoji: '🦘' },
        { italian: 'il gorilla', english: 'gorilla', emoji: '🦍' },
        { italian: 'il pipistrello', english: 'bat', emoji: '🦇' },
        { italian: 'il lupo', english: 'wolf', emoji: '🐺' },
        { italian: 'il cocodrillo', english: 'crocodile', emoji: '🐊' },
        { italian: "l'orso", english: 'bear', emoji: '🐻' },
        { italian: 'il delfino', english: 'dolphin', emoji: '🐬' },
        { italian: 'lo struzzo', english: 'ostrich', emoji: '🦤' },
        { italian: 'il pellicano', english: 'pelican', emoji: '🐦' },
        { italian: 'i leoncini', english: 'lion cubs', emoji: '🦁' },
      ],
    },
  
    {
      slug: 'animali_domestici',
      name: 'Gli Animali Domestici',
      emoji: '🐶',
      words: [
        { italian: 'il cane', english: 'dog', emoji: '🐕' },
        { italian: 'il cagnolino', english: 'puppy', emoji: '🐶' },
        { italian: 'il gatto', english: 'cat', emoji: '🐈' },
        { italian: 'il gattino', english: 'kitten', emoji: '🐱' },
        { italian: 'il topolino', english: 'mouse', emoji: '🐭' },
        { italian: 'il coniglio', english: 'rabbit', emoji: '🐰' },
        { italian: 'il criceto', english: 'hamster', emoji: '🐹' },
        { italian: "il porcellino d'India", english: 'guinea pig', emoji: '🐾' },
        { italian: 'il pappagallo', english: 'parrot', emoji: '🦜' },
        { italian: 'il pappagallino', english: 'budgie / parakeet', emoji: '🦜' },
        { italian: 'il canarino', english: 'canary', emoji: '🐦' },
        { italian: 'i pesci rossi', english: 'goldfish', emoji: '🐠' },
        { italian: 'la gabbia', english: 'cage', emoji: '🔒' },
        { italian: 'la cuccia', english: 'dog kennel', emoji: '🏠' },
        { italian: 'la cesta', english: 'basket', emoji: '🧺' },
        { italian: 'il cibo', english: 'food (pet food)', emoji: '🍖' },
        { italian: 'il becco', english: 'beak', emoji: '🐦' },
        { italian: 'il latte', english: 'milk', emoji: '🥛' },
        { italian: 'il veterinario', english: 'vet', emoji: '👨‍⚕️' },
      ],
    },
  
    {
      slug: 'campagna',
      name: 'La Campagna',
      emoji: '🌄',
      words: [
        { italian: 'la collina', english: 'hill', emoji: '⛰️' },
        { italian: 'il villaggio', english: 'village', emoji: '🏘️' },
        { italian: 'il ponte', english: 'bridge', emoji: '🌉' },
        { italian: 'il canale', english: 'canal', emoji: '🌊' },
        { italian: 'la cascata', english: 'waterfall', emoji: '💧' },
        { italian: 'la galleria', english: 'tunnel', emoji: '🚇' },
        { italian: 'la roulotte', english: 'caravan', emoji: '🚐' },
        { italian: 'le tende', english: 'tents', emoji: '⛺' },
        { italian: 'i massi', english: 'rocks / boulders', emoji: '🪨' },
        { italian: 'il rospo', english: 'toad', emoji: '🐸' },
        { italian: 'la falena', english: 'moth', emoji: '🦋' },
        { italian: 'il gufo', english: 'owl', emoji: '🦉' },
        { italian: 'i volpacchiotti', english: 'fox cubs', emoji: '🦊' },
        { italian: 'la talpa', english: 'mole', emoji: '🐾' },
        { italian: 'il pescatore', english: 'fisherman', emoji: '🎣' },
        { italian: 'la chiatta', english: 'barge', emoji: '⛴️' },
        { italian: 'i ceppi', english: 'logs', emoji: '🪵' },
        { italian: 'il mulino a vento', english: 'windmill', emoji: '🌬️' },
        { italian: 'la mongolfiera', english: 'hot air balloon', emoji: '🎈' },
        { italian: 'la farfalla', english: 'butterfly', emoji: '🦋' },
        { italian: 'la lucertola', english: 'lizard', emoji: '🦎' },
        { italian: 'le pietre', english: 'stones', emoji: '🪨' },
        { italian: 'la volpe', english: 'fox', emoji: '🦊' },
        { italian: 'il ruscello', english: 'stream', emoji: '🌊' },
        { italian: 'il riccio', english: 'hedgehog', emoji: '🦔' },
        { italian: 'lo scoiattolo', english: 'squirrel', emoji: '🐿️' },
        { italian: 'la foresta', english: 'forest', emoji: '🌲' },
        { italian: 'il tasso', english: 'badger', emoji: '🦡' },
        { italian: 'il fiume', english: 'river', emoji: '🌊' },
        { italian: 'la strada', english: 'road', emoji: '🛣️' },
      ],
    },
  
    {
      slug: 'fattoria',
      name: 'La Fattoria',
      emoji: '🐄',
      words: [
        { italian: "l'agricoltore", english: 'farmer', emoji: '👨‍🌾' },
        { italian: 'il campo', english: 'field', emoji: '🌾' },
        { italian: 'la mucca', english: 'cow', emoji: '🐄' },
        { italian: 'il vitello', english: 'calf', emoji: '🐂' },
        { italian: 'le galline', english: 'hens / chickens', emoji: '🐔' },
        { italian: 'le pecore', english: 'sheep', emoji: '🐑' },
        { italian: 'i maiali', english: 'pigs', emoji: '🐖' },
        { italian: 'i maialini', english: 'piglets', emoji: '🐷' },
        { italian: 'i tacchini', english: 'turkeys', emoji: '🦃' },
        { italian: 'il cavallo', english: 'horse', emoji: '🐴' },
        { italian: 'la stalla', english: 'stable / barn', emoji: '🏚️' },
        { italian: 'la scuderia', english: 'stable (horses)', emoji: '🐴' },
        { italian: "l'aratro", english: 'plough', emoji: '🌾' },
        { italian: 'il fieno', english: 'hay', emoji: '🌾' },
        { italian: 'le balle di paglia', english: 'hay bales', emoji: '🌾' },
        { italian: 'la sella', english: 'saddle', emoji: '🐴' },
        { italian: 'la staccionata', english: 'fence', emoji: '🪵' },
        { italian: 'il frutteto', english: 'orchard', emoji: '🍎' },
        { italian: 'il pastore', english: 'shepherd', emoji: '🐑' },
        { italian: 'lo spaventapasseri', english: 'scarecrow', emoji: '🌾' },
        { italian: 'la casa colonica', english: 'farmhouse', emoji: '🏡' },
        { italian: 'il cane pastore', english: 'sheepdog', emoji: '🐕' },
        { italian: 'le anatre', english: 'ducks', emoji: '🦆' },
        { italian: 'gli agnelli', english: 'lambs', emoji: '🐑' },
        { italian: 'lo stagno', english: 'pond', emoji: '🌊' },
        { italian: 'i pulcini', english: 'chicks', emoji: '🐣' },
        { italian: 'il fienile', english: 'barn', emoji: '🏚️' },
        { italian: 'il porcile', english: 'pigpen', emoji: '🐖' },
        { italian: 'il toro', english: 'bull', emoji: '🐂' },
        { italian: 'gli anattroccoli', english: 'duckling', emoji: '🐥' },
        { italian: 'il pollaio', english: 'chicken coop', emoji: '🐔' },
        { italian: 'il fango', english: 'mud', emoji: '💧' },
      ],
    },
  
    {
      slug: 'mare',
      name: 'Il Mare & La Spiaggia',
      emoji: '🏖️',
      words: [
        { italian: 'la spiaggia', english: 'beach', emoji: '🏖️' },
        { italian: 'le onde', english: 'waves', emoji: '🌊' },
        { italian: 'la scogliera', english: 'cliff / rocks', emoji: '🪨' },
        { italian: 'la nave', english: 'ship', emoji: '🚢' },
        { italian: 'la canoa', english: 'canoe', emoji: '🛶' },
        { italian: 'la barca a remi', english: 'rowing boat', emoji: '🚣' },
        { italian: 'il peschereccio', english: 'fishing boat', emoji: '⛵' },
        { italian: 'la petroliera', english: 'oil tanker', emoji: '🚢' },
        { italian: 'il pesce', english: 'fish', emoji: '🐟' },
        { italian: 'le pinne', english: 'flippers', emoji: '🤿' },
        { italian: 'la rete', english: 'net', emoji: '🕸️' },
        { italian: 'la pagaia', english: 'paddle', emoji: '🛶' },
        { italian: 'la fune', english: 'rope', emoji: '🪢' },
        { italian: 'i ciottoli', english: 'pebbles', emoji: '🪨' },
        { italian: 'le alghe', english: 'seaweed', emoji: '🌿' },
        { italian: 'il cappello', english: 'sun hat', emoji: '🎩' },
        { italian: 'il costume da bagno', english: 'swimsuit', emoji: '🩱' },
        { italian: 'la sedia a sdraio', english: 'deck chair', emoji: '🪑' },
        { italian: 'il gabbiano', english: 'seagull', emoji: '🐦' },
        { italian: 'le conchiglie', english: 'shells', emoji: '🐚' },
        { italian: 'gli scogli', english: 'reef', emoji: '🪨' },
        { italian: 'la barca a vela', english: 'sailboat', emoji: '⛵' },
        { italian: 'il faro', english: 'lighthouse', emoji: '🗼' },
        { italian: 'la paletta per la sabbia', english: 'shovel', emoji: '⛏️' },
        { italian: 'il secchiello', english: 'bucket', emoji: '🪣' },
        { italian: 'la stella marina', english: 'starfish', emoji: '⭐' },
        { italian: 'il castello di sabbia', english: 'sandcastle', emoji: '🏰' },
        { italian: "l'ombrellone", english: 'beach umbrella', emoji: '⛱️' },
        { italian: 'la bandiera', english: 'flag', emoji: '🚩' },
        { italian: 'il granchio', english: 'crab', emoji: '🦀' },
        { italian: "l'isola", english: 'island', emoji: '🏝️' },
        { italian: 'il motoscafo', english: 'motorboat', emoji: '🚤' },
      ],
    },
  
    {
      slug: 'parco',
      name: 'Il Parco',
      emoji: '🌳',
      words: [
        { italian: 'il bebé', english: 'baby', emoji: '👶' },
        { italian: 'i bambini', english: 'children', emoji: '👧' },
        { italian: 'la palla', english: 'ball', emoji: '⚽' },
        { italian: 'il triciclo', english: 'tricycle', emoji: '🚲' },
        { italian: 'lo skateboard', english: 'skateboard', emoji: '🛹' },
        { italian: 'il passeggino', english: 'stroller', emoji: '🍼' },
        { italian: "l'altalena a bilico", english: 'seesaw', emoji: '⚖️' },
        { italian: 'gli uccelli', english: 'birds', emoji: '🐦' },
        { italian: 'la cancellata', english: 'fence', emoji: '🪵' },
        { italian: 'la barchetta', english: 'small boat', emoji: '⛵' },
        { italian: 'la pozzanghera', english: 'puddle', emoji: '💧' },
        { italian: 'gli anatroccoli', english: 'ducklings', emoji: '🐥' },
        { italian: 'le anatre', english: 'ducks', emoji: '🦆' },
        { italian: 'i cigni', english: 'swans', emoji: '🦢' },
        { italian: 'il guinzaglio', english: 'dog lead / leash', emoji: '🐕' },
        { italian: 'la corda per saltare', english: 'skipping rope', emoji: '🪢' },
        { italian: "l'aiuola", english: 'flower bed', emoji: '🌺' },
        { italian: 'gli alberi', english: 'trees', emoji: '🌳' },
        { italian: 'la terra', english: 'ground / earth', emoji: '🌍' },
        { italian: "l'altalena", english: 'swing', emoji: '🎠' },
        { italian: 'la buca di sabbia', english: 'sandpit', emoji: '🏖️' },
        { italian: "l'aquilone", english: 'kite', emoji: '🪁' },
        { italian: 'il gelato', english: 'ice cream', emoji: '🍦' },
        { italian: 'il cane', english: 'dog', emoji: '🐕' },
        { italian: 'il cancello', english: 'gate', emoji: '🚪' },
        { italian: 'lo scivolo', english: 'slide', emoji: '🎿' },
        { italian: 'i girini', english: 'froglet', emoji: '🐸' },
        { italian: 'il lago', english: 'lake', emoji: '🏞️' },
        { italian: 'i pattini', english: 'rollerblades', emoji: '⛸️' },
        { italian: 'il cespuglio', english: 'bush', emoji: '🌿' },
      ],
    },
  
    // ══════════════════════════════════════════════════════════════════════
    // EXTRA VOCABULARY
    // ══════════════════════════════════════════════════════════════════════
  
    {
      slug: 'officina',
      name: "L'Officina & Gli Attrezzi",
      emoji: '🔧',
      words: [
        { italian: 'il martello', english: 'hammer', emoji: '🔨' },
        { italian: 'i chiodi', english: 'nails', emoji: '📌' },
        { italian: 'le bullette', english: 'tacks' },
        { italian: 'i bulloni', english: 'bolts', emoji: '🔩' },
        { italian: 'i dadi', english: 'nuts (bolts)', emoji: '🔩' },
        { italian: 'la ragnatela', english: "spider's web", emoji: '🕸️' },
        { italian: 'il ragno', english: 'spider', emoji: '🕷️' },
        { italian: 'la mosca', english: 'fly', emoji: '🪰' },
        { italian: "l'ascia", english: 'axe', emoji: '🪓' },
        { italian: 'il metro', english: 'tape measure', emoji: '📏' },
        { italian: 'la lima', english: 'file (tool)' },
        { italian: 'la vernice', english: 'paint / varnish', emoji: '🎨' },
        { italian: 'il legno', english: 'wood', emoji: '🪵' },
        { italian: 'il piano di lavoro', english: 'workbench' },
        { italian: 'i barattoli', english: 'tins / jars', emoji: '🫙' },
        { italian: 'la pialla', english: 'plane (tool)' },
        { italian: 'la botte', english: 'barrel', emoji: '🛢️' },
        { italian: 'le viti', english: 'screws', emoji: '🔩' },
        { italian: 'la morsa', english: 'clamp' },
        { italian: 'la carta vetrata', english: 'sandpaper' },
        { italian: 'il trapano', english: 'drill', emoji: '🔧' },
        { italian: 'la scala', english: 'ladder', emoji: '🪜' },
        { italian: 'la sega', english: 'saw', emoji: '🪚' },
        { italian: 'la segatura', english: 'sawdust' },
        { italian: 'la cassetta degli arnesi', english: 'toolbox', emoji: '🧰' },
        { italian: 'il cacciavite', english: 'screwdriver', emoji: '🪛' },
        { italian: "l'asse", english: 'plank / board', emoji: '🪵' },
        { italian: 'i trucioli', english: 'wood shavings' },
        { italian: 'il coltellino', english: 'penknife / pocket knife', emoji: '🔪' },
      ],
    },
  
    {
      slug: 'scuola',
      name: 'La Scuola',
      emoji: '📚',
      words: [
        { italian: "l'insegnante", english: 'teacher', emoji: '👩‍🏫' },
        { italian: "l'alfabeto", english: 'alphabet', emoji: '🔤' },
        { italian: 'il quaderno', english: 'notebook', emoji: '📓' },
        { italian: 'la carta geografica', english: 'map', emoji: '🗺️' },
        { italian: 'il mappamondo', english: 'globe', emoji: '🌍' },
        { italian: 'il pennello', english: 'paintbrush', emoji: '🖌️' },
        { italian: 'i pastelli', english: 'crayons', emoji: '🖍️' },
        { italian: 'gli acquarelli', english: 'watercolour paints', emoji: '🎨' },
        { italian: 'la carta', english: 'paper', emoji: '📄' },
        { italian: 'le forbici', english: 'scissors', emoji: '✂️' },
        { italian: 'la colla', english: 'glue', emoji: '🫙' },
        { italian: 'la matita', english: 'pencil', emoji: '✏️' },
        { italian: 'il righello', english: 'ruler', emoji: '📏' },
        { italian: 'la gomma', english: 'rubber / eraser', emoji: '✏️' },
        { italian: 'la scatola', english: 'box', emoji: '📦' },
        { italian: 'il cestino della carta', english: 'waste paper bin', emoji: '🗑️' },
        { italian: 'il cavalletto', english: 'easel', emoji: '🎨' },
        { italian: 'la lavagna', english: 'blackboard', emoji: '📋' },
        { italian: 'il banco', english: 'school desk', emoji: '🪑' },
        { italian: 'la spilla', english: 'badge / pin', emoji: '📌' },
        { italian: "l'acquario", english: 'fish tank', emoji: '🐠' },
        { italian: 'i pennarelli', english: 'markers', emoji: '🖊️' },
        { italian: 'le puntine da disegno', english: 'drawing pins', emoji: '📌' },
        { italian: 'i colori', english: 'colors', emoji: '🎨' },
        { italian: 'i libri', english: 'books', emoji: '📚' },
        { italian: 'la penna', english: 'pen', emoji: '🖊️' },
        { italian: 'i gessetti', english: 'chalk', emoji: '🖍️' },
        { italian: 'il disegno', english: 'drawing', emoji: '✏️' },
      ],
    },
  
    {
      slug: 'giocattoli',
      name: 'Il Negozio di Giocattoli',
      emoji: '🧸',
      words: [
        { italian: "l'arco", english: 'bow (archery)', emoji: '🏹' },
        { italian: 'il paracadute', english: 'parachute', emoji: '🪂' },
        { italian: 'la barca', english: 'boat (toy)', emoji: '⛵' },
        { italian: 'le maschere', english: 'masks', emoji: '🎭' },
        { italian: 'la macchina da corsa', english: 'racing car (toy)', emoji: '🏎️' },
        { italian: 'il cavallo a dondolo', english: 'rocking horse', emoji: '🐴' },
        { italian: 'il salvadanaio', english: 'piggy bank', emoji: '🐷' },
        { italian: 'le biglie', english: 'marbles', emoji: '🔵' },
        { italian: 'le marionette', english: 'puppets', emoji: '🎭' },
        { italian: 'il pianoforte', english: 'piano', emoji: '🎹' },
        { italian: 'gli astronauti', english: 'astronauts', emoji: '👨‍🚀' },
        { italian: 'il razzo', english: 'rocket', emoji: '🚀' },
        { italian: 'la gru', english: 'crane (toy)', emoji: '🏗️' },
        { italian: 'la plastilina', english: 'plasticine', emoji: '🎨' },
        { italian: 'il fucile', english: 'toy gun / rifle', emoji: '🔫' },
        { italian: 'i soldatini', english: 'toy soldiers', emoji: '🪖' },
        { italian: 'gli acquarelli', english: 'watercolour paints', emoji: '🎨' },
        { italian: 'i colori per il viso', english: 'face paints', emoji: '🎨' },
        { italian: 'il trenino', english: 'toy train', emoji: '🚂' },
        { italian: 'i tamburi', english: 'drums', emoji: '🥁' },
        { italian: 'le perline', english: 'beads', emoji: '📿' },
        { italian: 'le bambole', english: 'dolls', emoji: '🪆' },
        { italian: 'la chitarra', english: 'guitar', emoji: '🎸' },
        { italian: 'le costruzioni', english: 'building blocks', emoji: '🧱' },
        { italian: 'le frecce', english: 'arrows', emoji: '🏹' },
      ],
    },
  
    {
      slug: 'festa',
      name: 'La Festa & I Dolci',
      emoji: '🎂',
      words: [
        { italian: 'la torta', english: 'cake', emoji: '🎂' },
        { italian: 'le candeline', english: 'birthday candles', emoji: '🕯️' },
        { italian: 'il palloncino', english: 'balloon', emoji: '🎈' },
        { italian: 'il panino', english: 'sandwich / roll', emoji: '🥪' },
        { italian: 'il biscotto', english: 'biscuit / cookie', emoji: '🍪' },
        { italian: 'il pane', english: 'bread', emoji: '🍞' },
        { italian: 'il burro', english: 'butter', emoji: '🧈' },
        { italian: 'le patatine', english: 'crisps / chips', emoji: '🍟' },
        { italian: 'la salsiccia', english: 'sausage', emoji: '🌭' },
        { italian: 'la ciliegia', english: 'cherry', emoji: '🍒' },
        { italian: 'il lampone', english: 'raspberry', emoji: '🍓' },
        { italian: 'la fragola', english: 'strawberry', emoji: '🍓' },
        { italian: 'il succo di frutta', english: 'fruit juice', emoji: '🧃' },
        { italian: 'la tovaglia', english: 'tablecloth', emoji: '🍽️' },
        { italian: 'i costumi', english: 'fancy dress costumes', emoji: '🎭' },
        { italian: 'il cioccolato', english: 'chocolate', emoji: '🍫' },
        { italian: 'la caramella', english: 'candy', emoji: '🍬' },
        { italian: 'le decorazioni di carta', english: 'paper decorations', emoji: '🎉' },
      ],
    },
  
    {
      slug: 'contrari',
      name: 'I Contrari & Gli Aggettivi',
      emoji: '↔️',
      words: [
        { italian: 'fuori', english: 'outside' },
        { italian: 'dentro', english: 'inside' },
        { italian: 'facile', english: 'easy', emoji: '😊' },
        { italian: 'difficile', english: 'difficult', emoji: '😓' },
        { italian: 'vuoto', english: 'empty', emoji: '🫙' },
        { italian: 'pieno', english: 'full', emoji: '🫙' },
        { italian: 'morbido', english: 'soft' },
        { italian: 'duro', english: 'hard' },
        { italian: 'davanti', english: 'in front' },
        { italian: 'dietro', english: 'behind' },
        { italian: 'alto', english: 'high / tall', emoji: '📏' },
        { italian: 'basso', english: 'low / short' },
        { italian: 'lento', english: 'slow', emoji: '🐢' },
        { italian: 'veloce', english: 'fast', emoji: '🐇' },
        { italian: 'lungo', english: 'long' },
        { italian: 'corto', english: 'short' },
        { italian: 'scuro', english: 'dark', emoji: '🌑' },
        { italian: 'chiaro', english: 'light / bright', emoji: '☀️' },
        { italian: 'vecchio', english: 'old', emoji: '🏚️' },
        { italian: 'nuovo', english: 'new', emoji: '✨' },
        { italian: 'morto', english: 'dead', emoji: '💀' },
        { italian: 'vivo', english: 'alive', emoji: '💚' },
        { italian: 'su', english: 'up', emoji: '⬆️' },
        { italian: 'giù', english: 'down', emoji: '⬇️' },
        { italian: 'destra', english: 'right', emoji: '➡️' },
        { italian: 'sinistra', english: 'left', emoji: '⬅️' },
        { italian: 'buono', english: 'good', emoji: '😊' },
        { italian: 'cattivo', english: 'bad', emoji: '😈' },
        { italian: 'freddo', english: 'cold', emoji: '🧊' },
        { italian: 'caldo', english: 'hot', emoji: '🔥' },
        { italian: 'bagnato', english: 'wet', emoji: '💧' },
        { italian: 'asciutto', english: 'dry' },
        { italian: 'sporco', english: 'dirty', emoji: '🤢' },
        { italian: 'pulito', english: 'clean', emoji: '✨' },
        { italian: 'sopra', english: 'on', emoji: '⬆️' },
        { italian: 'sotto', english: 'under', emoji: '⬇️' },
        { italian: 'robusto', english: 'chubby' },
        { italian: 'magro', english: 'skinny' },
        { italian: 'aperto', english: 'open', emoji: '🔓' },
        { italian: 'chiuso', english: 'closed', emoji: '🔒' },
        { italian: 'piccolo', english: 'small', emoji: '🐭' },
        { italian: 'grande', english: 'big', emoji: '🐘' },
        { italian: 'pochi', english: 'a few' },
        { italian: 'molti', english: 'many' },
        { italian: 'primo', english: 'first', emoji: '1️⃣' },
        { italian: 'ultimo', english: 'last' },
      ],
    },
  
    {
      slug: 'forme',
      name: 'Le Forme',
      emoji: '🔷',
      words: [
        { italian: 'un rettangolo', english: 'rectangle', emoji: '▬' },
        { italian: 'un rombo', english: 'rhombus', emoji: '🔷' },
        { italian: 'un cono', english: 'cone', emoji: '🍦' },
        { italian: 'una stella', english: 'star', emoji: '⭐' },
        { italian: 'un cerchio', english: 'circle', emoji: '⭕' },
        { italian: 'un cubo', english: 'cube', emoji: '🎲' },
        { italian: 'un ovale', english: 'oval', emoji: '🥚' },
        { italian: 'un triangolo', english: 'triangle', emoji: '🔺' },
        { italian: 'un quadrato', english: 'square', emoji: '🟥' },
      ],
    },
  
    {
      slug: 'lunapark',
      name: 'Il Luna Park',
      emoji: '🎡',
      words: [
        { italian: 'la ruota panoramica', english: 'Ferris wheel', emoji: '🎡' },
        { italian: 'la giostra', english: 'carousel', emoji: '🎠' },
        { italian: 'lo scivolo', english: 'slide', emoji: '🎿' },
        { italian: 'il tiro a cerchietto', english: 'ring toss' },
        { italian: 'il treno fantasma', english: 'ghost train', emoji: '👻' },
        { italian: 'i pop-corn', english: 'popcorn', emoji: '🍿' },
        { italian: 'le montagne russe', english: 'roller coaster', emoji: '🎢' },
        { italian: 'il tiro a segno', english: 'target shooting', emoji: '🎯' },
        { italian: "l'autoscontro", english: 'bumper cars', emoji: '🚗' },
        { italian: 'lo zucchero filato', english: 'cotton candy', emoji: '🍭' },
      ],
    },
  
    {
      slug: 'circo',
      name: 'Il Circo',
      emoji: '🎪',
      words: [
        { italian: 'il pagliaccio', english: 'clown', emoji: '🤡' },
        { italian: 'il giocoliere', english: 'juggler', emoji: '🤹' },
        { italian: "l'equilibrista", english: 'tightrope walker', emoji: '🎪' },
        { italian: 'il funambolo', english: 'tightrope walker', emoji: '🎪' },
        { italian: 'gli acrobati', english: 'acrobats', emoji: '🤸' },
        { italian: 'il domatore', english: 'animal tamer', emoji: '🦁' },
        { italian: 'il trapezio', english: 'trapeze', emoji: '🎪' },
        { italian: 'la scala di corda', english: 'rope ladder', emoji: '🪜' },
        { italian: 'la rete di sicurezza', english: 'safety net', emoji: '🕸️' },
        { italian: "l'asta", english: 'pole', emoji: '🏒' },
        { italian: 'il cerchio', english: 'hoop', emoji: '⭕' },
        { italian: 'il cilindro', english: 'top hat', emoji: '🎩' },
        { italian: 'il farfallino', english: 'bow tie', emoji: '🎀' },
        { italian: 'camminare sulla corda', english: 'to walk the tightrope', emoji: '🎪' },
        { italian: "l'orchestra", english: 'orchestra / band', emoji: '🎶' },
        { italian: 'la cavallerizza', english: 'circus horse rider', emoji: '🐴' },
      ],
    },
    {
        slug: 'parole_utili',
        name: 'Parole Utili',
        emoji: '💡',
        words: [
          { italian: 'anche', english: 'also', emoji: '➕' },
          { italian: 'ancora', english: 'still / yet / again', emoji: '⏳' },
          { italian: 'adesso', english: 'now', emoji: '⏰' },
          { italian: 'a volte', english: 'sometimes', emoji: '🔄' },
          { italian: 'altrimenti', english: 'otherwise', emoji: '↔️' },
          { italian: 'appena', english: 'as soon as', emoji: '⚡' },
          { italian: 'come', english: 'how', emoji: '❓' },
          { italian: 'che cosa', english: 'what', emoji: '❓' },
          { italian: 'cosa', english: 'what', emoji: '❓' },
          { italian: 'chi', english: 'who', emoji: '❓' },
          { italian: 'con', english: 'with', emoji: '🤝' },
          { italian: 'dopo', english: 'after', emoji: '⏩' },
          { italian: 'difficile', english: 'difficult', emoji: '😓' },
          { italian: 'dentro', english: 'inside', emoji: '📦' },
          { italian: 'di solito', english: 'usually', emoji: '🔄' },
          { italian: 'dietro', english: 'behind', emoji: '👀' },
          { italian: 'dappertutto', english: 'everywhere', emoji: '🌍' },
          { italian: 'ecco', english: 'here / there you go', emoji: '✨' },
          { italian: 'forse', english: 'maybe', emoji: '🤔' },
          { italian: 'finalmente', english: 'finally', emoji: '🎉' },
          { italian: 'fino a', english: 'until', emoji: '⏳' },
          { italian: 'facile', english: 'easy', emoji: '😊' },
          { italian: 'fuori', english: 'outside', emoji: '🌿' },
          { italian: 'già', english: 'already / yet', emoji: '✅' },
          { italian: 'infatti', english: 'in fact / indeed', emoji: '💬' },
          { italian: 'intorno', english: 'around', emoji: '🔄' },
          { italian: 'insieme', english: 'together', emoji: '🤝' },
          { italian: 'inoltre', english: 'furthermore', emoji: '➕' },
          { italian: 'lì / là', english: 'there', emoji: '📍' },
          { italian: 'lontano', english: 'far', emoji: '🗺️' },
          { italian: 'lentamente', english: 'slowly', emoji: '🐢' },
          { italian: 'mentre', english: 'while', emoji: '⏱️' },
          { italian: 'niente', english: 'nothing', emoji: '🚫' },
          { italian: 'nonostante', english: 'although', emoji: '↔️' },
          { italian: 'ogni', english: 'each / every', emoji: '🔢' },
          { italian: 'ogni tanto', english: 'sometimes', emoji: '🔄' },
          { italian: 'ora', english: 'now / hour', emoji: '⏰' },
          { italian: 'perché', english: 'why / because', emoji: '❓' },
          { italian: 'prima', english: 'before', emoji: '⏮️' },
          { italian: 'prima di tutto', english: 'first of all', emoji: '1️⃣' },
          { italian: 'perciò', english: 'for this reason', emoji: '➡️' },
          { italian: 'però', english: 'however', emoji: '↔️' },
          { italian: 'più tardi', english: 'later', emoji: '⏰' },
          { italian: 'presto', english: 'soon', emoji: '⚡' },
          { italian: 'poi', english: 'then', emoji: '➡️' },
          { italian: 'quasi', english: 'almost', emoji: '🎯' },
          { italian: 'qui / qua', english: 'here', emoji: '📍' },
          { italian: 'quindi', english: 'so / therefore', emoji: '➡️' },
          { italian: 'qualcuno', english: 'someone', emoji: '🧑' },
          { italian: 'qualcosa', english: 'something', emoji: '📦' },
          { italian: 'quando', english: 'when', emoji: '📅' },
          { italian: 'quanto', english: 'how much', emoji: '❓' },
          { italian: 'quale', english: 'which', emoji: '❓' },
          { italian: 'subito', english: 'immediately', emoji: '⚡' },
          { italian: 'sebbene', english: 'although', emoji: '↔️' },
          { italian: 'senza', english: 'without', emoji: '🚫' },
          { italian: 'sotto', english: 'under', emoji: '⬇️' },
          { italian: 'sempre', english: 'always', emoji: '♾️' },
          { italian: 'spesso', english: 'often', emoji: '🔄' },
          { italian: 'se', english: 'if', emoji: '❓' },
          { italian: 'tuttavia', english: 'however', emoji: '↔️' },
          { italian: 'una volta', english: 'once / one time', emoji: '1️⃣' },
          { italian: 'veramente', english: 'really', emoji: '💯' },
          { italian: 'vicino a', english: 'close to', emoji: '📍' },
          { italian: 'purtroppo', english: 'unfortunately', emoji: '😔' },
          { italian: 'fortunatamente', english: 'fortunately', emoji: '🍀' },
          { italian: 'comunque', english: 'anyway', emoji: '🤷' },
          { italian: 'magari', english: 'maybe / I wish', emoji: '✨' },
          { italian: 'davvero', english: 'really / truly', emoji: '💯' },
          { italian: 'abbastanza', english: 'enough / quite', emoji: '👌' },
          { italian: 'troppo', english: 'too much', emoji: '⚠️' },
          { italian: 'poco', english: 'a little', emoji: '🤏' },
          { italian: 'tanto', english: 'a lot', emoji: '💪' },
          { italian: 'almeno', english: 'at least', emoji: '📊' },
        ],
      },
  ];
  
  // ─── Helpers ──────────────────────────────────────────────────────────────────
  export const getTopicBySlug = (slug) =>
    TOPICS.find(t => t.slug === slug) || { slug, name: slug, emoji: '📝', words: [] };

  export const ALL_TOPIC_SLUGS = TOPICS.map(t => t.slug);